import React, { Fragment, useEffect, useState } from "react";
import {
  ArrowNarrowDownIcon,
  ArrowNarrowUpIcon,
  CalendarIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  CogIcon,
  DownloadIcon,
  PlusIcon,
  SearchIcon,
  XCircleIcon,
} from "@heroicons/react/solid";
import {
  Col,
  Row,
  Nav,
  Card,
  Form,
  Button,
  Modal,
  Table,
  Dropdown,
  Pagination,
  Tooltip,
  ButtonGroup,
  OverlayTrigger,
  InputGroup,
  ToastContainer,
  Toast,
} from "react-bootstrap";
import { Link, useHistory, useLocation } from "react-router-dom";
import { BsImageFill } from "react-icons/bs";

import { Routes } from "routes";
import Datetime from "react-datetime";
import {
  useContactGetUploadListMutation,
  useGetWhatsappTemplatesMutation,
  useUserDataMutation,
  useApproveUserMutation,
  useTransactionalListMutation,
  useDeleteListMutation,
  useGetSMSTemplatesMutation,
  useBlacklistSMSTemplatesMutation,
  useGetRoutesListMutation,
  useGetMsgRatesListMutation,
  useDeactivateWhatsTemplatesMutation,
  useGetRegisteredAccountsMutation,
  useUserDropDownMutation,
  useGetRegisteredSMSCAccountsMutation,
  useRegisteredSMSRateManagementMutation,
  useGetVendorListMutation,
  useCreateRouteMutation,
  useGetVendorTableMutation,
  useEnterpriseGroupMutation,
  useDnldUserDataMutation,
  useDnldSMSCAccountsDataMutation,
  useDnldSMSCRatesMutation,
  useDnldWARatesMutation,
  useDnldVendorsListMutation,
  useDnldVendorWalletMutation,
  useDnldEntWalletMutation,
  useDnldSMSAccountsMutation,
  useDnldSMSTemplatesMutation,
  useDnldWhatsAppTemplatesMutation,
  useDeleteSmsAccountMutation,
  useDeleteSmscAccountMutation,
  useDeleteVendorAccountMutation,
  useDeleteAnyUserMutation,
  useGetStoredAPIsMutation,
  useDnldSavedApisMutation,
  useDeleteSavedAPIsMutation,
} from "Services/services";
import moment from "moment-timezone";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { TbArrowsSort, TbDeviceMobileMessage, TbEdit } from "react-icons/tb";
import Select from "react-select";
import CopiedAlert from "pages/components/CopyAlert";
import { GrDocumentText } from "react-icons/gr";
import { FaCircleUser } from "react-icons/fa6";
import {
  MdAppBlocking,
  MdOutlineContentCopy,
  MdOutlineRefresh,
  MdVideoLibrary,
} from "react-icons/md";
import { PiArrowSquareUpRight, PiPhone } from "react-icons/pi";
import { IoDocumentTextOutline } from "react-icons/io5";
import hasPermission from "pages/Permissions";
import { downloadBlobFile } from "./Utility";
import {
  useGetRegisteredRcsTemplatesMutation,
  useDownloadRegisteredRcsTemplatesMutation,
  useDeactivateRcsTemplatesMutation,
  useGetRcsOnboardedBSPMutation,
  useGetRcsAssignedRoutesMutation,
} from "Services/rcsServices";
import { RCS_PROVIDERS } from "../utils/constant";

const { KARIX, SMART_PING } = RCS_PROVIDERS;

const capitalizeFirstLetter = (string) =>
  string[0].toUpperCase() + string.slice(1).toLowerCase();

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: "btn btn-secondary me-3",
      cancelButton: "btn btn-gray",
    },
    buttonsStyling: false,
  })
);

// on Contact List
export const ContactListTable = (props) => {
  const listTab = props.listType;

  const [tableData, setTableData] = useState([]);

  const [searchValue, setSearchValue] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const startDate = start ? moment(start).format("YYYY-MM-DD") : "";
  const endDate = end ? moment(end).format("YYYY-MM-DD") : "";

  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);

  const [contactListApi] = useContactGetUploadListMutation();
  const [deleteListApi] = useDeleteListMutation();

  const [showAlert, setShowAlert] = useState(false);
  const [text, setText] = useState(false);

  const [debouncedValue, setDebouncedValue] = useState("");

  // Get the id from localStorage
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const userId = userObject.id;

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 1000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  useEffect(() => {
    const fetchTableData = async () => {
      contactListApi({
        user_id: "",
        page: currentPage,
        limit: pagelimit,
        search: debouncedValue,
        fromDate: startDate,
        toDate: endDate,
        list_type: listTab,
      })
        .then((response) => {
          if (response?.data?.data?.response?.statusCode === 200) {
            setTableData(response?.data?.data?.response?.data || []);
            setTotalPages(response?.data?.data?.response?.totalPages || 0);
            setTotalPosts(response?.data?.data?.response?.totalRecords || 0);
          } else {
            setTableData([]);
            setTotalPages(0);
            setTotalPosts(0);
            // alert("Failed to fetch user data");
          }
        })
        .catch((error) => {
          setTableData([]);
          setTotalPages(0);
          setTotalPosts(0);
          // alert("Error fetching user data", error);
        });
    };
    fetchTableData();
  }, [debouncedValue, pagelimit, currentPage, startDate, endDate, listTab]);

  const changeSearchValue = (e) => {
    setSearchValue(e.target.value);
  };

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const deleteUsers = async (ids) => {
    const usersToBeDeleted = ids;
    const textMessage = "Are you sure you want to delete this List?";

    const result = await SwalWithBootstrapButtons.fire({
      icon: "success",
      title: "Confirm deletion",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      const newUsers = tableData.filter(
        (f) => !usersToBeDeleted.includes(f.id)
      );

      deleteListApi({ id: ids })
        .then((response) => {
          if (response?.data?.statusCode === 200) {
            setMessage("The List has been deleted.");
          } else {
            setError("Failed to Delete.");
          }
        })
        .catch((error) => {
          setError("Error deleting this list." || error);
        });

      error === ""
        ? await SwalWithBootstrapButtons.fire("Deleted", message, "success")
        : await SwalWithBootstrapButtons.fire("Failed", error, "error");

      setTableData(newUsers);
    }
  };

  const downloadList = async (listname) => {
    try {
      const encodedListName = encodeURIComponent(listname);
      const response = await fetch(
        `${process.env.REACT_APP_API_PORT}/get_listed_contact?user_id=${userId}&list_name=${encodedListName}&export=true`
      );

      console.log("response status", response.status);

      // Check if the response is successful
      if (!response.ok) {
        const errorText = await response.text(); // Capture error message as text if provided
        setShowAlert(true);
        setText(errorText || "An error occurred while downloading the file.");
        return;
      }

      // Process the binary data
      const blob = await response.blob();

      // Sanitize the filename
      const sanitizedFileName = `${listname.replace(
        /[<>:"/\\|?*#]/g,
        "_"
      )}.xlsx`;

      // Create the download link
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = sanitizedFileName; // Use the sanitized listname as the file name
      downloadLink.click();

      // Show success alert
      setShowAlert(true);
      setText(`File "${sanitizedFileName}" downloaded successfully`);
    } catch (error) {
      // Handle unexpected errors
      console.error("Unexpected error:", error);
      setShowAlert(true);
      setText("An unexpected error occurred. Please try again.");
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const canDelete = hasPermission("Contact List", "delete");
  const canDownload = hasPermission("Contact List", "download");

  const TableRow = (props) => {
    return (
      <tr className="border-bottom">
        <td>
          <span className="fw-normal " title={props.list_name || "-"}>
            {props.list_name || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal " title={props.user_name || "-"}>
            {props.user_name || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal " title={props.remark || "-"}>
            {props.remark || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.count || "-"}>
            {props.count || "-"}
          </span>
        </td>
        <td>
          <span
            className="fw-normal"
            title={moment(props.upload_date).format("DD/MM/YYYY") || "-"}
          >
            {moment(props.upload_date).format("DD/MM/YYYY")}
          </span>
        </td>
        {(canDownload || canDelete) && (
          <td>
            <div className="d-flex gap-2">
              {canDownload && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Download</Tooltip>}
                >
                  <Card.Link
                    className="ms-2"
                    onClick={() => downloadList(props.list_name)}
                  >
                    <DownloadIcon className="icon icon-xxs text-info" />
                  </Card.Link>
                </OverlayTrigger>
              )}
              {canDelete && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Delete</Tooltip>}
                >
                  <Card.Link
                    className="ms-2"
                    onClick={() => deleteUsers([props.id])}
                  >
                    <XCircleIcon className="icon icon-xxs text-danger" />
                  </Card.Link>
                </OverlayTrigger>
              )}
            </div>
          </td>
        )}
      </tr>
    );
  };

  return (
    <Card border={1}>
      <CopiedAlert
        showAlert={showAlert}
        setShowAlert={setShowAlert}
        value={text}
      />
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
        <InputGroup className="fmxw-300">
          <InputGroup.Text>
            <SearchIcon className="icon icon-xs" />
          </InputGroup.Text>
          <Form.Control
            type="search"
            placeholder="List Name/Remarks"
            value={searchValue}
            onChange={changeSearchValue}
          />
        </InputGroup>

        <Form.Group id="DateRange">
          <InputGroup className="d-flex flex-nowrap">
            <InputGroup.Text
              onClick={() => {
                setStart(null);
                setEnd(null);
              }}
            >
              {start || end ? (
                <XCircleIcon className="icon icon-xs" />
              ) : (
                <CalendarIcon className="icon icon-xs" />
              )}
            </InputGroup.Text>
            <Datetime
              timeFormat={false}
              onChange={(date) => {
                if (moment.isMoment(date)) {
                  setStart(date);
                }
              }}
              closeOnSelect={true}
              renderInput={(props, openCalendar) => (
                <Form.Control
                  type="search"
                  placeholder="Start Date"
                  value={start ? moment(start).format("DD/MM/YYYY") : ""}
                  onFocus={openCalendar}
                  readOnly
                  style={{ width: "150px", borderRadius: "0" }}
                />
              )}
            />
            <Datetime
              timeFormat={false}
              onChange={(date) => {
                if (moment.isMoment(date)) {
                  setEnd(date);
                }
              }}
              closeOnSelect={true}
              isValidDate={(currDate) => currDate.isAfter(start)}
              initialViewDate={end}
              renderInput={(props, openCalendar) => (
                <Form.Control
                  type="search"
                  placeholder="End Date"
                  value={end ? moment(end).format("DD/MM/YYYY") : ""}
                  onFocus={openCalendar}
                  readOnly
                  style={{
                    width: "150px",
                    borderTopLeftRadius: "0",
                    borderBottomLeftRadius: "0",
                  }}
                />
              )}
            />
          </InputGroup>
        </Form.Group>

        <ButtonGroup className="ms-auto">
          <Dropdown>
            <Dropdown.Toggle
              split
              as={Button}
              variant="outline-gray-300"
              className="text-dark m-0 p-2"
            >
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
              <span className="small ps-2 fw-bold text-dark">
                Rows per page
              </span>
              {[10, 20, 30].map((limit) => (
                <Dropdown.Item
                  key={limit}
                  className={`d-flex align-items-center fw-bold ${
                    limit === 30 ? "rounded-bottom" : ""
                  }`}
                  onClick={() => {
                    setPagelimit(limit); // Update the page limit
                    setCurrentPage(1); // Reset the page number to 1
                  }}
                >
                  {limit}{" "}
                  {pagelimit === limit && (
                    <CheckIcon className="icon icon-xxs ms-auto" />
                  )}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </ButtonGroup>
      </div>
      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-bottom">List Name</th>
                <th className="border-bottom">Enterprise User</th>
                <th className="border-bottom">Remarks</th>
                <th className="border-bottom">Total Count</th>
                <th className="border-bottom">Upload Date</th>
                {(canDownload || canDelete) && (
                  <th className="border-bottom">Action</th>
                )}
              </tr>
            </thead>
            <tbody className="border-0">
              {tableData.length > 0 ? (
                tableData.map((u, index) => (
                  <TableRow key={index + 1} index={index + 1} {...u} />
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    <span className="text-danger">No Data Found</span>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      <Card.Footer className="p-0 mt-3 border-0 d-flex flex-wrap align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage - 1)}
              >
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage + 1)}
              >
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </Nav>
        <small className="fw-normal small mt-2 mt-md-0">
          Showing{" "}
          <b>
            {totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-
            {pagelimit * currentPage > totalPosts
              ? totalPosts
              : pagelimit * currentPage}
          </b>{" "}
          of <b>{totalPosts}</b> entries.
        </small>
      </Card.Footer>
    </Card>
  );
};
//on UserOnboardingList
export const UserOnboardingListTable = ({ handleEdit }) => {
  const [users, setUsers] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [crmValue, setCrmValue] = useState();
  const [statusValue, setStatusValue] = useState();

  const [searchValue, setSearchValue] = useState("");
  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);
  const [debouncedValue, setDebouncedValue] = useState("");

  const [userType, setUserType] = useState("");
  // const [status, setStatus] = useState("");

  // Get the usertype from localStorage
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const user = userObject.user_type;
  const userId = userObject.id;

  const [deleteUserApi] = useDeleteAnyUserMutation();
  const [download] = useDnldUserDataMutation();

  // const disabledBulkMenu = users.filter((u) => u.isSelected).length === 0;
  // const selectedUsersIds = users.filter((u) => u.isSelected).map((u) => u.id);
  // const totalUsers = users.length;
  // const allSelected = selectedUsersIds.length === totalUsers;
  const selectUserTypeOptions =
    user === "enterprise"
      ? [
          { value: "7", label: "Enterprise User" },
          { value: "6", label: "Enterprise Reporting User" },
        ]
      : [
          { value: "2", label: "Admin" },
          { value: "3", label: "Customer Relationship Manager" },
          { value: "4", label: "Enterprise Admin" },
          { value: "7", label: "Enterprise User" },
          { value: "8", label: "Enterprise Reporting User" },
        ];

  // const [approve] = useApproveUserMutation();

  // Sorting state
  const [sortField, setSortField] = useState("");
  const [sortDirection, setSortDirection] = useState("");

  // Sort function for Enterprise Name
  const handleSort = (field) => {
    if (sortField !== field) {
      // user clicked a new column → always start with ASC
      setSortField(field);
      setSortDirection("ASC");
    } else {
      // user clicked the same column → cycle ASC → DESC → none
      if (sortDirection === "") {
        setSortDirection("ASC");
      } else if (sortDirection === "ASC") {
        setSortDirection("DESC");
      } else if (sortDirection === "DESC") {
        setSortDirection("");
      }
    }
  };

  const [userOnboardingApi] = useUserDataMutation();
  const [onboardedUsers] = useEnterpriseGroupMutation();

  const fetchTableData = () => {
    if (user === "enterprise") {
      onboardedUsers({
        pageNumber: currentPage,
        limit: pagelimit,
        user_id: userId,
        search: searchValue,
        user_type: crmValue,
        sortBy: sortField,
        sortOrder: sortDirection,
      })
        .then((response) => {
          if (response?.data?.statusCode === 200) {
            setTableData(response?.data?.data.result.data || []);
            setTotalPosts(response?.data?.data.result.totalPosts || 0);
            setTotalPages(response?.data?.data.result.totalPages || 0);
          } else {
            setTableData([]);
            setTotalPages(0);
            setTotalPosts(0);
            console.error("Failed to fetch user data");
          }
        })
        .catch((error) => {
          setTableData([]);
          setTotalPages(0);
          setTotalPosts(0);
          console.error("Error fetching user data", error);
        });
    } else {
      userOnboardingApi({
        pageNumber: currentPage,
        limit: pagelimit,
        user_type: crmValue,
        search: searchValue,
        status: statusValue,
        sortBy: sortField,
        sortOrder: sortDirection,
      })
        .then((response) => {
          if (response?.data?.statusCode === 200) {
            setTableData(response?.data?.data.result.data || []);
            setTotalPosts(response?.data?.data.result.totalPosts || 0);
            setTotalPages(response?.data?.data.result.totalPages || 0);
          } else {
            setTableData([]);
            setTotalPages(0);
            setTotalPosts(0);
          }
        })
        .catch((error) => {
          setTableData([]);
          setTotalPages(0);
          setTotalPosts(0);
        });
    }
  };

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 1000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  useEffect(() => {
    fetchTableData();
  }, [
    debouncedValue,
    pagelimit,
    currentPage,
    crmValue,
    userType,
    statusValue,
    sortField,
    sortDirection,
  ]);

  useEffect(() => {
    const updatedUsers =
      Array.isArray(tableData) && tableData.length > 0
        ? tableData.map((u) => ({ ...u, isSelected: false, show: true }))
        : [];

    setUsers(updatedUsers);
    // setTotalPage(tableData/pagelimit)
  }, [tableData]);

  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    // if (currentPage < totalPages) {
    setCurrentPage(currentPage + 1);
    // }
  };

  const selectUserType = (selectedOption) => {
    if (selectedOption != null) {
      setCrmValue(selectedOption.value);
    } else return setCrmValue("");
  };

  const deleteUsers = async (ids) => {
    const textMessage = "Are you sure you want to delete this User?";
    const result = await SwalWithBootstrapButtons.fire({
      icon: "question",
      title: "Confirm deletion",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel"
    });
    if (result.isConfirmed) {
      deleteUserApi({ user_id: ids })
        .then(async (response) => {
          console.log("response", response.data);

          if (response?.data?.statusCode === 200) {
            const msg = response?.data?.message || "The User has been deleted.";
            await SwalWithBootstrapButtons.fire(
              "Deleted",
              msg,
              "success"
            );
            fetchTableData();
          } else {
            const failureMsg = "Failed to Delete.";
            await SwalWithBootstrapButtons.fire("Failed", failureMsg, "error");
          }
        })
        .catch(async (error) => {
          const errMsg = error?.message || "Error deleting this Account.";
          await SwalWithBootstrapButtons.fire("Failed", errMsg, "error");
        });
    }
  };

  const canEdit = hasPermission("User Management", "edit");
  const canDownload = hasPermission("User Management", "download");
  const canDelete = hasPermission("User Management", "delete");
  const handleDownload = async () => {
    try {
      const blob = await download({
        user_type: crmValue,
        search: searchValue,
        status: statusValue,
        login_user_type: userObject.user_type_id || "1",
        created_by_userid: userId,
      }).unwrap();
      downloadBlobFile(blob, "Onboarded_Users.csv");
    } catch (err) {
      if (err.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };

  const TableRow = (props) => {
    const statusVariant =
      props.status === "approved"
        ? "success"
        : props.status === "pending"
        ? "warning"
        : "danger";

    return (
      <tr className="border-bottom">
        <td>
          <span className="fw-normal d-flex align-items-center">
            {props.id || "-"}
          </span>
        </td>
        <td>
          <span
            className="fw-normal "
            style={{ maxWidth: "150px" }}
            title={props.user_name || "-"}
          >
            {props.user_name || "-"}
          </span>
        </td>
        <td>
          <span
            className="fw-normal "
            style={{ maxWidth: "150px" }}
            title={props.name || "-"}
          >
            {props.name || "-"}
          </span>
        </td>
        {user !== "enterprise" && (
          <td>
            <span
              className="fw-normal "
              style={{ maxWidth: "150px" }}
              title={props.associated_enterprise_name || "-"}
            >
              {props.associated_enterprise_name || "-"}
            </span>
          </td>
        )}
        <td>
          <span
            className="fw-normal "
            style={{ maxWidth: "200px" }}
            title={props.email || "-"}
          >
            {props.email || "-"}
          </span>
        </td>
        <td>
          <span
            className="fw-normal "
            style={{ maxWidth: "120px" }}
            title={props.user_type || "-"}
          >
            {props.user_type || "-"}
          </span>
        </td>
        <td>
          <span
            className="fw-normal "
            style={{ maxWidth: "120px" }}
            title={props.phone || "-"}
          >
            {props.phone || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal">
            {moment(props?.createdAt).format("DD/MM/YYYY")}
          </span>
        </td>
        <td>
          <span className="fw-normal">
            {moment(props?.expiry_date).format("DD/MM/YYYY")}
          </span>
        </td>
        {user !== "enterprise" && (
          <td>
            <span
              className="fw-normal "
              style={{ maxWidth: "200px" }}
              title={
                props.reported_users !== null
                  ? props.reported_users
                      .map((user) => user.user_name)
                      .join(", ")
                  : "-"
              }
            >
              {props.reported_users !== null
                ? props.reported_users.map((user) => user.user_name).join(", ")
                : "-"}
            </span>
          </td>
        )}
        <td>
          <span
            className="fw-normal "
            style={{ maxWidth: "150px" }}
            title={props.created_by_user_name || "-"}
          >
            {props.created_by_user_name || "-"}
          </span>
        </td>
        <td>
          <span
            className="fw-normal "
            style={{ maxWidth: "150px" }}
            title={props.customer_relation_manager_name || "-"}
          >
            {props.customer_relation_manager_name || "-"}
          </span>
        </td>
        <td>
          <span className={`fw-normal text-${statusVariant}`}>
            {capitalizeFirstLetter(props.status) || "-"}
          </span>
        </td>
        {(canDelete || canEdit) && (
          <td>
            <div className="d-flex">
              {canEdit && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip className="m-0">Edit</Tooltip>}
                >
                  <Card.Link
                    className="ms-2 ms-auto"
                    onClick={() => handleEdit(props)}
                  >
                    <TbEdit className="icon icon-xxs text-info" />
                  </Card.Link>
                </OverlayTrigger>
              )}
              {canDelete && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip className="m-0">Delete</Tooltip>}
                >
                  <Card.Link
                    className="ms-2"
                    onClick={() => deleteUsers(props.id)}
                  >
                    <XCircleIcon className="icon icon-xxs text-danger" />
                  </Card.Link>
                </OverlayTrigger>
              )}
            </div>
          </td>
        )}
      </tr>
    );
  };

  return (
    <Fragment>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
        {/* Search Input */}
        <InputGroup className="fmxw-300">
          <InputGroup.Text>
            <SearchIcon className="icon icon-xs" />
          </InputGroup.Text>
          <Form.Control
            type="search"
            placeholder="Search Username / E-Mail"
            value={searchValue}
            onChange={changeSearchValue}
          />
        </InputGroup>

        <div className="fmxw-300 dataTable-filter">
          <Select
            isClearable
            options={selectUserTypeOptions}
            placeholder="Select User Type"
            value={userType}
            onChange={(selectedOption) => {
              setUserType(selectedOption);
              selectUserType(selectedOption);
            }}
            styles={{
              container: (provided) => ({
                ...provided,
                minWidth: "250px", // Set minimum width to handle longer labels
                maxWidth: "300px", // Set maximum width to prevent it from being too wide
              }),
              menu: (provided) => ({
                ...provided,
                width: "auto", // Adjust width based on content
                minWidth: "100%", // Ensure the dropdown is at least as wide as the select box
              }),
            }}
          />
        </div>

        {/* Filter by Status */}
        {/* <div className="me-2 me-lg-3 fmxw-300 dataTable-filter">
          <Row className="align-items-center">
            <Col xs="auto" className="ps-0 mb-0">
              <Select
                isClearable
                options={selectStatusTypeOptions}
                placeholder="--Select Status--"
                value={status}
                onChange={(selectedOption) => {
                  setStatus(selectedOption);
                  selectStatusType(selectedOption);
                }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    minWidth: "200px", // Set minimum width to handle longer labels
                    maxWidth: "250px", // Set maximum width to prevent it from being too wide
                  }),
                  menu: (provided) => ({
                    ...provided,
                    width: "auto", // Adjust width based on content
                    minWidth: "100%", // Ensure the dropdown is at least as wide as the select box
                  }),
                }}
              />
            </Col>
          </Row>
        </div> */}

        <div className="ms-auto d-flex gap-2">
          {canEdit && (
            <Button
              variant="secondary"
              className="d-flex align-items-center"
              as={Link}
              to={Routes.CreateUserManagement.path}
            >
              <PlusIcon className="icon icon-xs me-2" />
              Add User
            </Button>
          )}

          {canDownload && (
            <Button
              variant="outline-gray-300"
              className="d-inline-flex p-2 dnld"
              onClick={handleDownload}
            >
              <DownloadIcon className="icon icon-sm" />
            </Button>
          )}

          <Dropdown>
            <Dropdown.Toggle
              // split
              as={Button}
              variant="outline-gray-300"
              className="text-dark m-0 p-2"
            >
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
              <span className="small ps-2 fw-bold text-dark">Rows per page</span>
              {[10, 20, 30].map((limit) => (
                <Dropdown.Item
                  key={limit}
                  className={`d-flex align-items-center fw-bold ${
                    limit === 30 ? "rounded-bottom" : ""
                  }`}
                  onClick={() => {
                    setPagelimit(limit); // Update the page limit
                    setCurrentPage(1); // Reset the page number to 1
                  }}
                >
                  {limit}{" "}
                  {pagelimit === limit && (
                    <CheckIcon className="icon icon-xxs ms-auto" />
                  )}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-bottom">User ID</th>
                <th
                  className="border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("user_name")}
                >
                  <div className="d-flex align-items-center">
                    Username
                    <div className="ms-1">
                      {sortField === "user_name" ? (
                        sortDirection === "ASC" ? (
                          <ArrowNarrowUpIcon
                            className="icon icon-xxs"
                            title="Sort: Ascending"
                          />
                        ) : sortDirection === "DESC" ? (
                          <ArrowNarrowDownIcon
                            className="icon icon-xxs"
                            title="Sort: Descending"
                          />
                        ) : (
                          <TbArrowsSort
                            className="icon icon-xxs"
                            title="Sort: Initial"
                          />
                        )
                      ) : (
                        <TbArrowsSort
                          className="icon icon-xxs"
                          title="Sort: Initial"
                        />
                      )}
                    </div>
                  </div>
                </th>
                <th
                  className="border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("name")}
                >
                  <div className="d-flex align-items-center">
                    Name
                    <div className="ms-1">
                      {sortField === "name" ? (
                        sortDirection === "ASC" ? (
                          <ArrowNarrowUpIcon
                            className="icon icon-xxs"
                            title="Sort: Ascending"
                          />
                        ) : sortDirection === "DESC" ? (
                          <ArrowNarrowDownIcon
                            className="icon icon-xxs"
                            title="Sort: Descending"
                          />
                        ) : (
                          <TbArrowsSort
                            className="icon icon-xxs"
                            title="Sort: Initial"
                          />
                        )
                      ) : (
                        <TbArrowsSort
                          className="icon icon-xxs"
                          title="Sort: Initial"
                        />
                      )}
                    </div>
                  </div>
                </th>
                {user !== "enterprise" && (
                  <th className="border-bottom">Associated Enterprise</th>
                )}
                <th
                  className="border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("email")}
                >
                  <div className="d-flex align-items-center">
                    Email ID
                    <div className="ms-1">
                      {sortField === "email" ? (
                        sortDirection === "ASC" ? (
                          <ArrowNarrowUpIcon
                            className="icon icon-xxs"
                            title="Sort: Ascending"
                          />
                        ) : sortDirection === "DESC" ? (
                          <ArrowNarrowDownIcon
                            className="icon icon-xxs"
                            title="Sort: Descending"
                          />
                        ) : (
                          <TbArrowsSort
                            className="icon icon-xxs"
                            title="Sort: Initial"
                          />
                        )
                      ) : (
                        <TbArrowsSort
                          className="icon icon-xxs"
                          title="Sort: Initial"
                        />
                      )}
                    </div>
                  </div>
                </th>
                <th className="border-bottom">User Type</th>
                <th className="border-bottom">Mobile No.</th>
                <th className="border-bottom">Account Creation Date</th>
                <th className="border-bottom">Account Expiry Date</th>
                {user !== "enterprise" && (
                  <th className="border-bottom">Associated Enterprise User</th>
                )}
                <th
                  className="border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("created_by_user_name")}
                >
                  <div className="d-flex align-items-center">
                    Created By
                    <div className="ms-1">
                      {sortField === "created_by_user_name" ? (
                        sortDirection === "ASC" ? (
                          <ArrowNarrowUpIcon
                            className="icon icon-xxs"
                            title="Sort: Ascending"
                          />
                        ) : sortDirection === "DESC" ? (
                          <ArrowNarrowDownIcon
                            className="icon icon-xxs"
                            title="Sort: Descending"
                          />
                        ) : (
                          <TbArrowsSort
                            className="icon icon-xxs"
                            title="Sort: Initial"
                          />
                        )
                      ) : (
                        <TbArrowsSort
                          className="icon icon-xxs"
                          title="Sort: Initial"
                        />
                      )}
                    </div>
                  </div>
                </th>
                <th
                  className="border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("customer_relation_manager_name")}
                >
                  <div className="d-flex align-items-center">
                    Coordinated CRM
                    <div className="ms-1">
                      {sortField === "customer_relation_manager_name" ? (
                        sortDirection === "ASC" ? (
                          <ArrowNarrowUpIcon
                            className="icon icon-xxs"
                            title="Sort: Ascending"
                          />
                        ) : sortDirection === "DESC" ? (
                          <ArrowNarrowDownIcon
                            className="icon icon-xxs"
                            title="Sort: Descending"
                          />
                        ) : (
                          <TbArrowsSort
                            className="icon icon-xxs"
                            title="Sort: Initial"
                          />
                        )
                      ) : (
                        <TbArrowsSort
                          className="icon icon-xxs"
                          title="Sort: Initial"
                        />
                      )}
                    </div>
                  </div>
                </th>
                <th className="border-bottom" style={{ minWidth: "100px" }}>
                  Status
                </th>
                {(canDelete || canEdit) && (
                  <th className="border-bottom">Action</th>
                )}
              </tr>
            </thead>
            <tbody className="border-0">
              {users.length > 0 ? (
                users.map((u, index) => <TableRow key={index} {...u} />)
              ) : (
                <tr>
                  <td colSpan="11" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <Card.Footer className="p-0 mt-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage - 1)}
              >
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage + 1)}
              >
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </Nav>
        <small className="fw-normal mt-2 mt-md-0">
          Showing{" "}
          <b>
            {totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-
            {pagelimit * currentPage > totalPosts
              ? totalPosts
              : pagelimit * currentPage}
          </b>{" "}
          of <b>{totalPosts}</b> entries.
        </small>
      </Card.Footer>
    </Fragment>
  );
};

//on SMSRegistrationList
export const SMSRegistrationListTable = ({ handleEdit }) => {
  // const [users, setUsers] = useState([]);
  const [tableData, setTableData] = useState([]);
  // const [crmValue, setCrmValue] = useState();
  const [statusValue, setStatusValue] = useState();

  const [searchValue, setSearchValue] = useState("");
  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);

  // const [userType, setUserType] = useState("");
  const [status, setStatus] = useState("");

  // Sorting state
  const [sortField, setSortField] = useState("");
  const [sortDirection, setSortDirection] = useState("");

  // Get the usertype from localStorage
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const loggedUserType = userObject.user_type;

  // const disabledBulkMenu = users.filter((u) => u.isSelected).length === 0;
  // const selectedUsersIds = users.filter((u) => u.isSelected).map((u) => u.id);
  // const totalUsers = users.length;
  // const allSelected = selectedUsersIds.length === totalUsers;
  // const selectUserTypeOptions = [
  //   { value: "2", label: "Admin" },
  //   { value: "3", label: "Customer Relationship Manager" },
  //   { value: "4", label: "Enterprise" },
  //   { value: "5", label: "Biiling Ops" },
  //   { value: "6", label: "Reporting User" },
  // ];

  const [enterprise, setEnterprise] = useState([]);

  const [smsAccountRegisteredApi] = useGetRegisteredAccountsMutation();
  // const [approve] = useApproveUserMutation();
  const [deleteAccountsApi] = useDeleteSmsAccountMutation();

  const [userDropDown] = useUserDropDownMutation();
  const [download] = useDnldSMSAccountsMutation();

  // Sort function for Enterprise Name
  const handleSort = (field) => {
    if (sortField !== field) {
      // user clicked a new column → always start with ASC
      setSortField(field);
      setSortDirection("ASC");
    } else {
      // user clicked the same column → cycle ASC → DESC → none
      if (sortDirection === "") {
        setSortDirection("ASC");
      } else if (sortDirection === "ASC") {
        setSortDirection("DESC");
      } else if (sortDirection === "DESC") {
        setSortDirection("");
      }
    }
  };

  const fetchUserDropdown = async () => {
    try {
      const response = await userDropDown({ user_type: "4" });
      if (response?.data?.statusCode === 200) {
        const userOptions = response.data.data.user_details.map((user) => ({
          value: user.id,
          label: user.user_name,
        }));
        setEnterprise(userOptions);
      } else {
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };

  useEffect(() => {
    fetchUserDropdown();
  }, []);

  const fetchTableData = async () => {
    smsAccountRegisteredApi({
      pageNumber: currentPage,
      limit: pagelimit,
      search: searchValue,
      enterprise_id:
        loggedUserType === "enterprise"
          ? userObject.id
          : loggedUserType === "enterprise_user"
          ? userObject.associated_enterprise_id
          : statusValue,
      sortBy: sortField,
      sortOrder: sortDirection,
    })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setTableData(response.data.data.get_registered_accounts || []);
          setTotalPosts(response?.data?.data?.totalRecords || 0);
          setTotalPages(response?.data?.data?.totalPages || 0);
        } else {
          setTableData([]);
          setTotalPages(0);
          setTotalPosts(0);
          console.error("Failed to fetch user data");
        }
      })
      .catch((error) => {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
        console.error("Error fetching user data", error);
      });
  };
  const [debouncedValue, setDebouncedValue] = useState("");

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 1000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  useEffect(() => {
    fetchTableData();
    // eslint-disable-next-line
  }, [
    debouncedValue,
    pagelimit,
    currentPage,
    statusValue,
    sortField,
    sortDirection,
  ]);

  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  // const userTypeMap = {
  //   1: "Super Admin",
  //   2: "Admin",
  //   4: "Enterprise",
  //   5: "Billing Ops",
  //   3: "Customer Relationship Manager",
  //   6: "Reporting User",
  // };

  // const crmMap = {
  //   1: "CRM1",
  //   2: "CRM2",
  //   3: "CRM3",
  //   4: "CRM4",
  //   5: "CRM5",
  // };

  // const selectUserType = (selectedOption) => {
  //   if (selectedOption != null) {
  //     setCrmValue(selectedOption.value);
  //   } else return setCrmValue("");
  // };
  const selectStatusType = (selectedOption) => {
    if (selectedOption != null) {
      setStatusValue(selectedOption.value);
    } else return setStatusValue("");
  };

  const deleteUsers = async (ids) => {
    // const usersToBeDeleted = ids;
    const textMessage = "Are you sure you want to delete this Account?";
    const result = await SwalWithBootstrapButtons.fire({
      icon: "question",
      title: "Confirm deletion",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });
    if (result.isConfirmed) {
      // const newUsers = tableData.filter(f => f.id !== usersToBeDeleted);
      deleteAccountsApi({ system_id: ids })
        .then(async (response) => {
          if (response?.data?.statusCode === 200) {
            await SwalWithBootstrapButtons.fire(
              "Deleted",
              "The Account has been deleted.",
              "success"
            );
            fetchTableData();
          } else {
            const failureMsg = "Failed to Delete.";
            await SwalWithBootstrapButtons.fire("Failed", failureMsg, "error");
          }
        })
        .catch(async (err) => {
          const errMsg = err?.message || "Error deleting this Account.";
          await SwalWithBootstrapButtons.fire("Failed", errMsg, "error");
        });
      // setTableData(newUsers);
    }
  };
  const canEdit = hasPermission("SMS SMPP Account", "edit");
  const canDownload = hasPermission("SMS SMPP Account", "download");
  const canDelete = hasPermission("SMS SMPP Account", "delete");

  const handleDownload = async () => {
    try {
      const blob = await download({
        search: searchValue,
        enterprise_id:
          loggedUserType === "enterprise"
            ? userObject.id
            : loggedUserType === "enterprise_user"
            ? userObject.associated_enterprise_id
            : statusValue,
        loggedin_user_id: userObject.id,
        user_type_id: userObject.user_type_id || "1",
        enterprise_user_id:
          loggedUserType === "enterprise_user" ? userObject.id : null,
      }).unwrap();
      downloadBlobFile(blob, "SMS_Accounts.csv");
    } catch (err) {
      if (err?.status === 404) alert("No Data for Download!");
      else alert("Download failed.");
    }
  };

  const TableRow = (props) => {
    const { index } = props;

    return (
      <tr className="border-bottom" key={index}>
        {loggedUserType !== "enterprise" && (
          <td>
            <span
              className="fw-normal "
              style={{ maxWidth: "150px" }}
              title={props.enterprise_admin_name || "-"}
            >
              {props.enterprise_admin_name || "-"}
            </span>
          </td>
        )}
        {loggedUserType !== "enterprise_user" && (
          <td>
            <span
              className="fw-normal "
              style={{ maxWidth: "150px" }}
              title={props.enterprise_user_name || "-"}
            >
              {props.enterprise_user_name || "-"}
            </span>
          </td>
        )}
        <td>
          <span
            className="fw-normal "
            style={{ maxWidth: "120px" }}
            title={props.system_id || "-"}
          >
            {props.system_id || "-"}
          </span>
        </td>
        <td>
          <span
            className="fw-normal "
            style={{ maxWidth: "150px" }}
            title={props.department_name || "-"}
          >
            {props.department_name || "-"}
          </span>
        </td>
        <td>
          <span
            className="fw-normal "
            style={{ maxWidth: "120px" }}
            title={props.Route || "-"}
          >
            {props.Route || "-"}
          </span>
        </td>
        <td>
          <span
            className="fw-normal "
            style={{ maxWidth: "100px" }}
            title={props.channel || "-"}
          >
            {props.channel || "-"}
          </span>
        </td>
        <td>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`tooltip-throughput-${props.id}`}>
                {props?.throughput || "-"}
              </Tooltip>
            }
          >
            <span className="fw-normal " style={{ maxWidth: "100px" }}>
              {props?.throughput || "-"}
            </span>
          </OverlayTrigger>
        </td>
        <td>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{props.connect_allow_ip || "-"}</Tooltip>}
          >
            <span className="fw-normal " style={{ maxWidth: "150px" }}>
              {props.connect_allow_ip || "-"}
            </span>
          </OverlayTrigger>
        </td>
        <td>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{props.dlt || "-"}</Tooltip>}
          >
            <span className="fw-normal " style={{ maxWidth: "100px" }}>
              {props.dlt || "-"}
            </span>
          </OverlayTrigger>
        </td>
        {/* <td><span className="fw-normal text-info">{props.default_cost || "-"}</span></td>
        <td><span className="fw-normal text-info">{props.dlt_cost || "-"}</span></td>
        <td><span className="fw-normal text-info">{props.refund_amount || "-"}</span></td>
        <td><span className="fw-normal text-info">{props.service_type || "-"}</span></td> */}
        {(canDelete || canEdit) && (
          <td>
            {canEdit && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip className="m-0">Edit</Tooltip>}
              >
                <Card.Link
                  className="ms-2 ms-auto"
                  onClick={() => handleEdit(props)}
                >
                  <TbEdit className="icon icon-xxs text-info" />
                </Card.Link>
              </OverlayTrigger>
            )}
            {canDelete && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip className="m-0">Delete</Tooltip>}
              >
                <Card.Link
                  className="ms-2"
                  onClick={() => deleteUsers(props.system_id)}
                >
                  <XCircleIcon className="icon icon-xxs text-danger" />
                </Card.Link>
              </OverlayTrigger>
            )}
          </td>
        )}
      </tr>
    );
  };

  return (
    <Fragment>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
        {/* Search Input */}
        <InputGroup className="d-flex flex-nowrap fmxw-500">
          <InputGroup.Text>
            <SearchIcon className="icon icon-xs" />
          </InputGroup.Text>
          <Form.Control
            type="search"
            placeholder={
              loggedUserType === "enterprise"
                ? "Search Enterprise User/System ID"
                : loggedUserType === "enterprise_user"
                ? "Search System ID"
                : "Search Enterprise Name/Enterprise User/System ID"
            }
            value={searchValue}
            onChange={changeSearchValue}
          />
        </InputGroup>

        {/* Filter by Status */}
        {loggedUserType !== "enterprise_user" &&
          loggedUserType !== "enterprise" && (
            <div className="fmxw-300 dataTable-filter">
              <Select
                isClearable
                options={enterprise}
                placeholder="Select Enterprise"
                value={status}
                onChange={(selectedOption) => {
                  setStatus(selectedOption);
                  selectStatusType(selectedOption); // your custom handler
                }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    minWidth: "250px",
                    maxWidth: "350px",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    width: "auto",
                    minWidth: "100%",
                  }),
                }}
              />
            </div>
          )}

        {/* <div className="me-2 me-lg-3 fmxw-300 dataTable-filter">
          <Row className="align-items-center">
            <Col xs="auto" className="ps-0 mb-0">
              <Select
                isClearable
                options={selectStatusTypeOptions}
                placeholder="--Select Name--"
                value={status}
                onChange={(selectedOption) => { setStatus(selectedOption); selectStatusType(selectedOption); }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    minWidth: '250px', // Set minimum width to handle longer labels
                    maxWidth: '350px', // Set maximum width to prevent it from being too wide
                  }),
                  menu: (provided) => ({
                    ...provided,
                    width: 'auto', // Adjust width based on content
                    minWidth: '100%', // Ensure the dropdown is at least as wide as the select box
                  }),
                }}
              />
            </Col>
          </Row>
        </div> */}

        {/* <div className="me-2 me-lg-3 fmxw-300 dataTable-filter">
          <Row className="align-items-center">
            <Col xs="auto" className="ps-0 mb-0">
              <Select
                isClearable
                options={selectUserTypeOptions}
                placeholder="--Select User Type--"
                value={userType}
                onChange={(selectedOption) => {
                  setUserType(selectedOption);
                  selectUserType(selectedOption);
                }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    minWidth: '200px', // Set minimum width to handle longer labels
                    maxWidth: '250px', // Set maximum width to prevent it from being too wide
                  }),
                  menu: (provided) => ({
                    ...provided,
                    width: 'auto', // Adjust width based on content
                    minWidth: '100%', // Ensure the dropdown is at least as wide as the select box
                  }),
                }}
              />
            </Col>
          </Row>
        </div> */}
        {/* Filter by Status */}
        {/* <div className="me-2 me-lg-3 fmxw-300 dataTable-filter">
          <Row className="align-items-center">
            <Col xs="auto" className="ps-0 mb-0">
              <Select
                isClearable
                options={selectStatusTypeOptions}
                placeholder="--Select Status--"
                value={status}
                onChange={(selectedOption) => { setStatus(selectedOption); selectStatusType(selectedOption); }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    minWidth: '200px', // Set minimum width to handle longer labels
                    maxWidth: '250px', // Set maximum width to prevent it from being too wide
                  }),
                  menu: (provided) => ({
                    ...provided,
                    width: 'auto', // Adjust width based on content
                    minWidth: '100%', // Ensure the dropdown is at least as wide as the select box
                  }),
                }}
              />
            </Col>
          </Row>
        </div> */}
        <div className="ms-auto d-flex gap-2 align-items-start">
          {canEdit && (
            <Button
              variant="secondary"
              className=" d-flex align-items-center"
              as={Link}
              to={Routes.CreateSMS.path}
            >
              <PlusIcon className="icon icon-xs me-2" /> Add Account
            </Button>
          )}

          {canDownload && (
            <Button
              variant="outline-gray-300" /* className="ms-auto d-inline-flex mb-3 me-2 position-relative" style={{ left: '10%' }} */
              onClick={handleDownload}
              className="p-2"
            >
              <DownloadIcon className="icon icon-sm" />
            </Button>
          )}

          <ButtonGroup>
            <Dropdown>
              <Dropdown.Toggle
                split
                as={Button}
                variant="outline-gray-300"
                className="text-dark m-0 p-2"
              >
                <CogIcon className="icon icon-sm" />
                <span className="visually-hidden">Toggle Dropdown</span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
                <span className="small ps-2 fw-bold text-dark">Rows per page</span>
                {[10, 20, 30].map((limit) => (
                  <Dropdown.Item
                    key={limit}
                    className={`d-flex align-items-center fw-bold ${
                      limit === 30 ? "rounded-bottom" : ""
                    }`}
                    onClick={() => {
                      setPagelimit(limit); // Update the page limit
                      setCurrentPage(1); // Reset the page number to 1
                    }}
                  >
                    {limit}{" "}
                    {pagelimit === limit && (
                      <CheckIcon className="icon icon-xxs ms-auto" />
                    )}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </ButtonGroup>
        </div>
      </div>
      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            hover
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                {loggedUserType !== "enterprise" && (
                  <th
                    className="border-bottom"
                    // style={{ cursor: "pointer" }}
                    // onClick={() => handleSort("enterprise_admin_name")}
                  >
                      Enterprise Name
                    {/* <div className="d-flex align-items-center">
                      <div className="ms-1">
                        {sortField === "enterprise_admin_name" ? (
                          sortDirection === "ASC" ? (
                            <ArrowNarrowUpIcon
                              className="icon icon-xxs"
                              title="Sort: Ascending"
                            />
                          ) : sortDirection === "DESC" ? (
                            <ArrowNarrowDownIcon
                              className="icon icon-xxs"
                              title="Sort: Descending"
                            />
                          ) : (
                            <TbArrowsSort
                              className="icon icon-xxs"
                              title="Sort: Initial"
                            />
                          )
                        ) : (
                          <TbArrowsSort
                            className="icon icon-xxs"
                            title="Sort: Initial"
                          />
                        )}
                      </div>
                    </div> */}
                  </th>
                )}
                {loggedUserType !== "enterprise_user" && (
                  <th className="border-bottom">Enterprise User</th>
                )}
                <th className="border-bottom">System ID</th>
                <th className="border-bottom">Remarks</th>
                <th
                  className="border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("Route")}
                >
                  <div className="d-flex align-items-center">
                    Route
                    <div className="ms-1">
                      {sortField === "Route" ? (
                        sortDirection === "ASC" ? (
                          <ArrowNarrowUpIcon
                            className="icon icon-xxs"
                            title="Sort: Ascending"
                          />
                        ) : sortDirection === "DESC" ? (
                          <ArrowNarrowDownIcon
                            className="icon icon-xxs"
                            title="Sort: Descending"
                          />
                        ) : (
                          <TbArrowsSort
                            className="icon icon-xxs"
                            title="Sort: Initial"
                          />
                        )
                      ) : (
                        <TbArrowsSort
                          className="icon icon-xxs"
                          title="Sort: Initial"
                        />
                      )}
                    </div>
                  </div>
                </th>
                <th className="border-bottom">Account Type</th>
                <th className="border-bottom">TPS</th>
                <th className="border-bottom">Allowed IP</th>
                <th className="border-bottom">DLT Type</th>
                {/* <th className="border-bottom">Cost</th>
                <th className="border-bottom">DLt Cost</th>
                <th className="border-bottom">Refund</th>
                <th className="border-bottom">Service Type</th> */}
                {(canDelete || canEdit) && (
                  <th className="border-bottom">Action</th>
                )}
              </tr>
            </thead>
            <tbody className="border-0">
              {tableData.length > 0 ? (
                tableData.map((u, index) => (
                  <TableRow key={index + 1} index={index + 1} {...u} />
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      <Card.Footer className="p-0 mt-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage - 1)}
              >
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage + 1)}
              >
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </Nav>
        <small className="fw-normal small mt-2 mt-md-0">
          Showing{" "}
          <b>
            {totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-
            {pagelimit * currentPage > totalPosts
              ? totalPosts
              : pagelimit * currentPage}
          </b>{" "}
          of <b>{totalPosts}</b> entries.
        </small>
      </Card.Footer>
    </Fragment>
  );
};
//on VendorRegistrationList
export const VendorRegistrationListTable = ({ handleEdit }) => {
  const [users, setUsers] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [crmValue, setCrmValue] = useState();
  const [statusValue, setStatusValue] = useState();

  const [searchValue, setSearchValue] = useState("");
  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);

  const [userType, setUserType] = useState("");
  // const [status, setStatus] = useState("");

  // Get the usertype from localStorage
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const user = userObject.user_type;

  // const disabledBulkMenu = users.filter((u) => u.isSelected).length === 0;
  // const selectedUsersIds = users.filter((u) => u.isSelected).map((u) => u.id);
  // const totalUsers = users.length;
  // const allSelected = selectedUsersIds.length === totalUsers;
  const selectUserTypeOptions = [
    { value: "2", label: "Admin" },
    { value: "3", label: "Customer Relationship Manager" },
    { value: "4", label: "Enterprise" },
    { value: "5", label: "Biiling Ops" },
    { value: "6", label: "Reporting User" },
  ];

  const selectStatusTypeOptions = [
    { value: "approved", label: "Approved" },
    { value: "rejected", label: "Rejected" },
  ];

  const [enterprise, setEnterprise] = useState([]);

  // const [smsAccountRegisteredApi] = useGetRegisteredAccountsMutation();
  const [vendorList] = useGetVendorListMutation();
  const [deleteAccountsApi] = useDeleteVendorAccountMutation();
  const [approve] = useApproveUserMutation();
  const [download] = useDnldVendorsListMutation();

  // Sorting state
  const [sortField, setSortField] = useState("");
  const [sortDirection, setSortDirection] = useState("");

  const [userDropDown] = useUserDropDownMutation();

  // Sort function for Enterprise Name
  const handleSort = (field) => {
    if (sortField !== field) {
      // user clicked a new column → always start with ASC
      setSortField(field);
      setSortDirection("ASC");
    } else {
      // user clicked the same column → cycle ASC → DESC → none
      if (sortDirection === "") {
        setSortDirection("ASC");
      } else if (sortDirection === "ASC") {
        setSortDirection("DESC");
      } else if (sortDirection === "DESC") {
        setSortDirection("");
      }
    }
  };

  const fetchUserDropdown = async () => {
    try {
      const response = await userDropDown({ user_type: "4" });
      if (response?.data?.statusCode === 200) {
        const userOptions = response.data.data.user_details.map((user) => ({
          value: user.id,
          label: `${user.user_type.toUpperCase()} : ${user.user_name}`,
        }));
        setEnterprise(userOptions);
      } else {
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };

  useEffect(() => {
    fetchUserDropdown();
  }, []);
  const fetchTableData = async () => {
    vendorList({
      page: currentPage,
      limit: pagelimit,
      search: searchValue,
      sortBy: sortField,
      sortOrder: sortDirection,
    })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setTableData(response?.data?.data?.items || []);
          setTotalPages(
            Math.ceil(response?.data?.data?.totalItems / pagelimit)
          );
          setTotalPosts(response?.data?.data?.totalItems || 0);
        } else {
          setTableData([]);
          setTotalPages(0);
          setTotalPosts(0);
          console.error("Failed to fetch user data", response);
        }
      })
      .catch((error) => {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
        console.error("Error fetching user data", error);
      });
  };
  const [debouncedValue, setDebouncedValue] = useState("");

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 1000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  // useEffect(() => {
  //   const updatedUsers =
  //     Array.isArray(tableData) && tableData.length > 0
  //       ? getSortedData(tableData).map((u) => ({
  //           ...u,
  //           isSelected: false,
  //           show: true,
  //         }))
  //       : [];

  //   setUsers(updatedUsers);
  //   // setTotalPage(tableData/pagelimit)
  // }, [tableData, sortField, sortDirection]);

  useEffect(() => {
    fetchTableData();
    // eslint-disable-next-line
  }, [
    debouncedValue,
    pagelimit,
    currentPage,
    crmValue,
    userType,
    statusValue,
    userType,
    sortDirection,
    sortField,
  ]);

  useEffect(() => {
    const updatedUsers =
      Array.isArray(tableData) && tableData.length > 0
        ? tableData.map((u) => ({ ...u, isSelected: false, show: true }))
        : [];

    setUsers(updatedUsers);
    // setTotalPage(tableData/pagelimit)
  }, [tableData]);

  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    // if (currentPage < totalPages) {
    setCurrentPage(currentPage + 1);
    // }
  };

  const selectUserType = (selectedOption) => {
    if (selectedOption != null) {
      setCrmValue(selectedOption.value);
    } else return setCrmValue("");
  };
  const selectStatusType = (selectedOption) => {
    if (selectedOption != null) {
      setStatusValue(selectedOption.value);
    } else return setStatusValue("");
  };

  // const handleReject = async (row) => {
  //   // Implement your remove logic here

  //   const textMessage = "Are you sure you want to reject this user?";

  //   const result = await SwalWithBootstrapButtons.fire({
  //     icon: "error",
  //     title: "Confirm Rejection",
  //     text: textMessage,
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "Cancel",
  //   });

  //   if (result.isConfirmed) {
  //     //127.0.0.1:7000
  //     try {
  //       const response = await approve({ user_id: row.id, approved: false });
  //       if (response?.data?.statusCode === 200) {
  //         const confirmMessage = "The user has been rejected successfully.";
  //         SwalWithBootstrapButtons.fire("Rejected", confirmMessage, "error");
  //         // Refetch data here
  //         fetchTableData();
  //       } else {
  //         const confirmMessage = "Failed to approve user";
  //         SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
  //       }
  //     } catch (error) {
  //       console.error("Error approving user", error);
  //       const confirmMessage = "An error occurred while approving the user.";
  //       SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
  //     }
  //   }
  // };

  const canEdit = hasPermission("Vendor Management", "edit");
  const canDownload = hasPermission("Vendor Management", "download");
  const canDelete = hasPermission("Vendor Management", "delete");

  const handleDelete = async (id) => {
    const textMessage = "Are you sure you want to delete this Account?";
    const result = await SwalWithBootstrapButtons.fire({
      icon: "question",
      title: "Confirm deletion",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });
    if (result.isConfirmed) {
      deleteAccountsApi({ id: id })
        .then(async (response) => {
          console.log("response", response.data);
          if (response?.data?.statusCode === 200) {
            await SwalWithBootstrapButtons.fire(
              "Deleted",
              "The Account has been deleted.",
              "success"
            );
            fetchTableData();
          } else {
            const failureMsg = "Failed to Delete.";
            await SwalWithBootstrapButtons.fire("Failed", failureMsg, "error");
          }
        })
        .catch(async (err) => {
          const errMsg = err?.message || "Error deleting this Account.";
          await SwalWithBootstrapButtons.fire("Failed", errMsg, "error");
        });
    }
  };

  const handleDownload = async () => {
    try {
      const blob = await download({
        vendor: searchValue,
        enterprise_id: "",
      }).unwrap();
      downloadBlobFile(blob, "Vendor_Lists.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };

  const TableRow = (props) => {
    const { index } = props;

    return (
      <tr className="border-bottom" key={index}>
        <td>
          <span className="fw-normal" title={props.vendor_name || "-"}>
            {props.vendor_name || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.username || "-"}>
            {props.username}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.vendor_country || "-"}>
            {props.vendor_country}
          </span>
        </td>
        <td>
          <span
            className="fw-normal"
            title={moment(props.createdAt).format("DD/MM/YYYY") || "-"}
          >
            {moment(props.createdAt).format("DD/MM/YYYY") || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.person_name || "-"}>
            {props.person_name}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.email || "-"}>
            {props.email || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.phone || "-"}>
            {props.phone || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.website_url || "-"}>
            {props.website_url || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.allow_ip || "-"}>
            {props.allow_ip || "-"}
          </span>
        </td>
        <td>
          <span
            className="fw-normal"
            title={moment(props.account_validity).format("DD/MM/YYYY") || "-"}
          >
            {moment(props.account_validity).format("DD/MM/YYYY") || "-"}
          </span>
        </td>
        {(canDelete || canEdit) && (
          <td>
            {canEdit && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip className="m-0">Edit</Tooltip>}
              >
                <Card.Link
                  className="ms-2 ms-auto"
                  onClick={() => handleEdit(props)}
                >
                  <TbEdit className="icon icon-xxs text-info" />
                </Card.Link>
              </OverlayTrigger>
            )}
            {canDelete && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip className="m-0">Delete</Tooltip>}
              >
                <Card.Link
                  className="ms-2"
                  onClick={() => handleDelete(props.id)}
                >
                  <XCircleIcon className="icon icon-xxs text-danger" />
                </Card.Link>
              </OverlayTrigger>
            )}
          </td>
        )}
      </tr>
    );
  };

  return (
    <Fragment>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
        {/* Search Input */}
        <InputGroup className="fmxw-500">
          <InputGroup.Text>
            <SearchIcon className="icon icon-xs" />
          </InputGroup.Text>
          <Form.Control
            type="search"
            placeholder="Search VendorName/Username/Contact Person/Email/Country"
            value={searchValue}
            onChange={changeSearchValue}
          />
        </InputGroup>

        {/* <div className="me-2 me-lg-3 fmxw-300 dataTable-filter">
          <Row className="align-items-center">
            <Col xs="auto" className="ps-0 mb-0">
              <Select
                isClearable
                options={enterprise}
                placeholder="--Select Enterprise--"
                value={status}
                onChange={(selectedOption) => {
                  setStatus(selectedOption);
                  selectStatusType(selectedOption); // your custom handler
                }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    minWidth: '250px',
                    maxWidth: '350px',
                  }),
                  menu: (provided) => ({
                    ...provided,
                    width: 'auto',
                    minWidth: '100%',
                  }),
                }}
              />

            </Col>
          </Row>
        </div> */}

        {/* <div className="me-2 me-lg-3 fmxw-300 dataTable-filter">
          <Row className="align-items-center">
            <Col xs="auto" className="ps-0 mb-0">
              <Select
                isClearable
                options={selectStatusTypeOptions}
                placeholder="--Select Name--"
                value={status}
                onChange={(selectedOption) => { setStatus(selectedOption); selectStatusType(selectedOption); }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    minWidth: '250px', // Set minimum width to handle longer labels
                    maxWidth: '350px', // Set maximum width to prevent it from being too wide
                  }),
                  menu: (provided) => ({
                    ...provided,
                    width: 'auto', // Adjust width based on content
                    minWidth: '100%', // Ensure the dropdown is at least as wide as the select box
                  }),
                }}
              />
            </Col>
          </Row>
        </div> */}

        <div className="ms-auto d-inline-flex gap-2">
          {canEdit && (
            <Button
              variant="secondary"
              className="d-flex align-items-center"
              as={Link}
              to={Routes.CreateVendorOnboarding.path}
            >
              <PlusIcon className="icon icon-xs me-2" /> Add Vendor
            </Button>
          )}

          {canDownload && (
            <Button
              variant="outline-gray-300"
              className="p-2"
              onClick={
                handleDownload
              } /* className="ms-auto d-inline-flex mb-3 me-2 position-relative" style={{ left: '10%' }} */
            >
              <DownloadIcon className="icon icon-sm" />
            </Button>
          )}

          <Dropdown>
            <Dropdown.Toggle
              split
              as={Button}
              variant="outline-gray-300"
              className="text-dark m-0 p-2"
            >
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
              <span className="small ps-2 fw-bold text-dark">Rows per page</span>
              {[10, 20, 30].map((limit) => (
                <Dropdown.Item
                  key={limit}
                  className={`d-flex align-items-center fw-bold ${
                    limit === 30 ? "rounded-bottom" : ""
                  }`}
                  onClick={() => {
                    setPagelimit(limit); // Update the page limit
                    setCurrentPage(1); // Reset the page number to 1
                  }}
                >
                  {limit}{" "}
                  {pagelimit === limit && (
                    <CheckIcon className="icon icon-xxs ms-auto" />
                  )}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                <th
                  className="border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("vendor_name")}
                >
                  <div className="d-flex align-items-center">
                    Vendor Name
                    <div className="ms-1">
                      {sortField === "vendor_name" ? (
                        sortDirection === "ASC" ? (
                          <ArrowNarrowUpIcon
                            className="icon icon-xxs"
                            title="Sort: Ascending"
                          />
                        ) : sortDirection === "DESC" ? (
                          <ArrowNarrowDownIcon
                            className="icon icon-xxs"
                            title="Sort: Descending"
                          />
                        ) : (
                          <TbArrowsSort
                            className="icon icon-xxs"
                            title="Sort: Initial"
                          />
                        )
                      ) : (
                        <TbArrowsSort
                          className="icon icon-xxs"
                          title="Sort: Initial"
                        />
                      )}
                    </div>
                  </div>
                </th>
                <th className="border-bottom">Username</th>
                <th
                  className="border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("vendor_country")}
                >
                  <div className="d-flex align-items-center">
                    Country
                    <div className="ms-1">
                      {sortField === "vendor_country" ? (
                        sortDirection === "ASC" ? (
                          <ArrowNarrowUpIcon
                            className="icon icon-xxs"
                            title="Sort: Ascending"
                          />
                        ) : sortDirection === "DESC" ? (
                          <ArrowNarrowDownIcon
                            className="icon icon-xxs"
                            title="Sort: Descending"
                          />
                        ) : (
                          <TbArrowsSort
                            className="icon icon-xxs"
                            title="Sort: Initial"
                          />
                        )
                      ) : (
                        <TbArrowsSort
                          className="icon icon-xxs"
                          title="Sort: Initial"
                        />
                      )}
                    </div>
                  </div>
                </th>
                <th
                  className="border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("createdAt")}
                >
                  <div className="d-flex align-items-center">
                    Created On
                    <div className="ms-1">
                      {sortField === "createdAt" ? (
                        sortDirection === "ASC" ? (
                          <ArrowNarrowUpIcon
                            className="icon icon-xxs"
                            title="Sort: Ascending"
                          />
                        ) : sortDirection === "DESC" ? (
                          <ArrowNarrowDownIcon
                            className="icon icon-xxs"
                            title="Sort: Descending"
                          />
                        ) : (
                          <TbArrowsSort
                            className="icon icon-xxs"
                            title="Sort: Initial"
                          />
                        )
                      ) : (
                        <TbArrowsSort
                          className="icon icon-xxs"
                          title="Sort: Initial"
                        />
                      )}
                    </div>
                  </div>
                </th>
                <th
                  className="border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("person_name")}
                >
                  <div className="d-flex align-items-center">
                    Contact Person Name
                    <div className="ms-1">
                      {sortField === "person_name" ? (
                        sortDirection === "ASC" ? (
                          <ArrowNarrowUpIcon
                            className="icon icon-xxs"
                            title="Sort: Ascending"
                          />
                        ) : sortDirection === "DESC" ? (
                          <ArrowNarrowDownIcon
                            className="icon icon-xxs"
                            title="Sort: Descending"
                          />
                        ) : (
                          <TbArrowsSort
                            className="icon icon-xxs"
                            title="Sort: Initial"
                          />
                        )
                      ) : (
                        <TbArrowsSort
                          className="icon icon-xxs"
                          title="Sort: Initial"
                        />
                      )}
                    </div>
                  </div>
                </th>
                <th className="border-bottom">Contact Email</th>
                <th className="border-bottom">Contact Phone</th>
                <th className="border-bottom">Website URL</th>
                <th className="border-bottom" style={{ minWidth: "100px" }}>
                  IP
                </th>
                <th className="border-bottom">Account Validity</th>
                {(canEdit || canDelete) && (
                  <th className="border-bottom">Action</th>
                )}
              </tr>
            </thead>
            <tbody className="border-0">
              {users.length > 0 ? (
                users.map((u, index) => (
                  <TableRow key={index + 1} index={index + 1} {...u} />
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      <Card.Footer className="p-0 mt-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage - 1)}
              >
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage + 1)}
              >
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </Nav>
        <small className="fw-normal small mt-2 mt-md-0">
          Showing{" "}
          <b>
            {totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-
            {pagelimit * currentPage > totalPosts
              ? totalPosts
              : pagelimit * currentPage}
          </b>{" "}
          of <b>{totalPosts}</b> entries.
        </small>
      </Card.Footer>
    </Fragment>
  );
};
//on default routing smsc table
export const DefulatRoutingSmscListTable = ({ handleEdit }) => {
  const location = useLocation();
  const passedData = location.state;
  // console.log("state data from parent component:::", passedData);
  const [tableData, setTableData] = useState([]);
  const [users, setUsers] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [pagelimit, setPagelimit] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPosts, setTotalPosts] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [apiRowData, setApiRowData] = useState([]);
  const [groups, setgroups] = useState([]);
  let [groupId, setgroupId] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [groupPercentages, setGroupPercentages] = useState({});
  const [margin, setMargin] = useState("");
  const [statusValue, setStatusValue] = useState("");
  const history = useHistory();

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("");

  const [getSmscRoutingList] = useRegisteredSMSRateManagementMutation();
  const [createRoute] = useCreateRouteMutation();

  // const selectStatusTypeOptions = [
  //   { value: "approved", label: "Approved" },
  //   { value: "rejected", label: "Rejected" },
  // ];

  const changeSearchValue = (e) => setSearchValue(e.target.value);
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleNext = () =>
    currentPage < totalPages && setCurrentPage(currentPage + 1);

  const fetchTableData = async () => {
    try {
      const response = await getSmscRoutingList({
        pageNumber: currentPage,
        limit: pagelimit,
        search: searchValue,
      });

      if (response?.data.statusCode === 200) {
        setTableData(response.data.data.rows || []);
        setTotalPosts(response.data.data.totalItems || 0);
        setTotalPages(response.data.data.totalPages || 0);
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    } catch (error) {
      setTableData([]);
      setTotalPages(0);
      setTotalPosts(0);
      console.error(
        "Error fetching SMSC routing list:::::::::::::::::::::::::",
        error
      );
    }
  };

  const [debouncedValue, setDebouncedValue] = useState("");
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(searchValue), 500);
    return () => clearTimeout(handler);
  }, [searchValue]);

  useEffect(() => {
    fetchTableData();
  }, [debouncedValue, pagelimit, currentPage]);

  useEffect(() => {
    const updatedUsers = Array.isArray(tableData)
      ? tableData.map((u) => ({ ...u, isSelected: false }))
      : [];
    setUsers(updatedUsers);
  }, [tableData]);

  // checkbox selection functionality
  const handleRowSelect = (id) => {
    setSelectedRows((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((item) => item !== id); // Unselect if already selected
      } else {
        return [...prevSelected, id]; // Add if not already selected
      }
    });
  };

  // data to create group functionality
  const handleRowDataSelect = (id) => {
    setSelectedRowData((prevSelectedData) => {
      const alreadySelected = prevSelectedData.some((item) => item.id === id);

      if (alreadySelected) {
        // Remove from both selectedRowData and apiRowData
        setApiRowData((prevData) => prevData.filter((item) => item.id !== id));
        return prevSelectedData.filter((item) => item.id !== id);
      } else {
        const data = tableData.find((item) => item.id === id);
        if (data) {
          // Add to both selectedRowData and apiRowData
          setApiRowData((prevData) => [...prevData, data]);
          return [...prevSelectedData, data];
        }
        return prevSelectedData; // fallback
      }
    });
  };

  // create group
  const handleCreateGroup = async () => {
    try {
      setgroups((prevSelectedData) => {
        setgroupId(++groupId);
        return [...prevSelectedData, { [`group${groupId}`]: selectedRowData }]; // Add if not already selected
      });
      const response = await getSmscRoutingList({
        pageNumber: currentPage,
        limit: pagelimit,
        search: searchValue,
        data: JSON.stringify(apiRowData),
      });
      if (response?.data.statusCode === 200) {
        setTableData(response.data.data.rows || []);
        setTotalPosts(response.data.data.totalItems || 0);
        setTotalPages(response.data.data.totalPages || 0);
        setSelectedRowData([]);
        setSelectedRows([]);
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    } catch (error) {
      console.error("Error fetching SMSC routing list:", error);
      setTableData([]);
      setTotalPages(0);
      setTotalPosts(0);
    }
  };

  const [gotError, setGotError] = useState(false);

  // final route creation api handling
  const handleCreateRoute = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!groups || !groupPercentages || !margin) {
      setGotError(true);
      return;
    }

    try {
      let keys = Object.keys(groupPercentages);
      let percentage = keys.map((key) => {
        return groupPercentages[key];
      });
      let payload = {
        enterprise_admin: passedData?.enterprise?.value,
        route_name: passedData?.routeName,
        user_chain: "super_admin#ent",
        group_id: "Dummy" + Math.random(),
        data: JSON.stringify(groups), //isme aapko 2d array m data daalna hoga
        percentage: percentage, // give me percentage
        margin: margin,
        channel: passedData?.channel,
      };
      const response = await createRoute(payload);
      if (response?.data.statusCode === 200) {
        setToastMessage(response?.data?.message);
        setToastVariant("success");

        setTimeout(() => {
          history.push(Routes.Routing.path);
        }, 2000);
        setSelectedRowData([]);
        setSelectedRows([]);
      } else {
        setToastMessage(response?.data?.message);
        setToastVariant("danger");
        setTableData([]);
      }
      setShowModal(false);
      setShowToast(true);
    } catch (error) {
      setToastMessage(error?.message || "Error");
      setToastVariant("danger");
      setShowToast(true);

      console.error("Error fetching SMSC routing list:", error);
      setTableData([]);
      setShowModal(false);
    }
  };

  const TableRow = ({ index, ...props }) => {
    return (
      <tr className="border-bottom">
        <td>
          <Form.Check
            type="checkbox"
            checked={selectedRows.includes(props.id)}
            onChange={() => {
              handleRowSelect(props.id);
              handleRowDataSelect(props.id);
            }}
          />
        </td>
        <td>
          <span className="fw-normal">{props.id || "-"}</span>
        </td>
        <td>
          <span className="fw-normal">{props.smsc || "-"}</span>
        </td>
        <td>
          <span className="fw-normal">{props.country}</span>
        </td>
        <td>
          <span className="fw-normal">{props.country_code}</span>
        </td>
        <td>
          <span className="fw-normal">{props.mcc}</span>
        </td>
        <td>
          <span className="fw-normal">{props.mnc}</span>
        </td>
        <td>
          <span className="fw-normal">{props.network}</span>
        </td>
        <td>
          <span className="fw-normal">{props.cost_price || "-"}</span>
        </td>
      </tr>
    );
  };

  return (
    <Fragment>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      {groups.length > 0 && (
        <Card className="mb-2">
          <h6 className="ms-2">Created Groups</h6>
          <Row>
            {groups.map((_, index) => (
              <Col md={4} key={index}>
                <Card className="border">
                  <div className="d-flex justify-content-between align-items-center">
                    <strong>Group {index + 1}</strong>

                    <span className="badge bg-primary">
                      {groups[index][`group${++index}`]?.length}
                      SMSCs
                    </span>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Card>
      )}

      <Card border={1}>
        <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
          <InputGroup className="fmxw-500">
            <InputGroup.Text>
              <SearchIcon className="icon icon-xs" />
            </InputGroup.Text>
            <Form.Control
              type="search"
              placeholder="Search SMSC/Country-Code/Country/MCC/MNC/Network"
              value={searchValue}
              onChange={changeSearchValue}
            />
          </InputGroup>

          {/* <div className="me-2 me-lg-3 fmxw-300">
          <Select
            isClearable
            options={selectStatusTypeOptions}
            placeholder="--Select Status--"
            value={statusValue}
            onChange={(option) => setStatusValue(option?.value || "")}
            styles={{
              container: (base) => ({
                ...base,
                minWidth: "250px",
                maxWidth: "350px",
              }),
            }}
          />
        </div> */}

          {/* <ButtonGroup className="ms-auto">
          <Dropdown>
            <Dropdown.Toggle split as={Button} variant="link" className="text-dark m-0 p-1">
              <CogIcon className="icon icon-sm" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end pb-0">
              <span className="small ps-3 fw-bold text-dark">Show</span>
              {[10, 20, 30].map(limit => (
                <Dropdown.Item key={limit} className="d-flex align-items-center fw-bold" onClick={() => { setPagelimit(limit); setCurrentPage(1); }}>
                  {limit} {pagelimit === limit && <CheckIcon className="icon icon-xxs ms-auto" />}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </ButtonGroup> */}
        </div>

        <div className="custom-scroll-wrapper">
          <div className="scroll-container">
            <Table
              responsive
              className="align-items-center table-flush table-outlines"
            >
              <thead className="thead-light">
                <tr>
                  {[
                    "Action",
                    "SMSC ID",
                    "SMSC",
                    "Country",
                    "Country Code",
                    "MCC",
                    "MNC",
                    "Network",
                    "Cost Price",
                  ].map((header, i) => (
                    <th className="border-bottom" key={i}>
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {users.length > 0 ? (
                  users.map((u, idx) => (
                    <TableRow key={idx} index={idx + 1} {...u} />
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center text-danger">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        <Card.Footer className="mt-3 p-0 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
          {/* <Nav>
              <Pagination className="mb-0">
                <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>Previous</Pagination.Prev>
                {currentPage >= 3 && <>
                  <Pagination.Item onClick={() => handlePageChange(1)}>1</Pagination.Item>
                  <Pagination.Ellipsis />
                </>}
                {currentPage > 1 && <Pagination.Item onClick={() => handlePageChange(currentPage - 1)}>{currentPage - 1}</Pagination.Item>}
                <Pagination.Item active>{currentPage}</Pagination.Item>
                {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
                {currentPage < totalPages - 1 && <>
                  <Pagination.Ellipsis />
                  <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>
                </>}
                <Pagination.Next onClick={handleNext} disabled={currentPage === totalPages}>Next</Pagination.Next>
              </Pagination>
            </Nav> */}
          {/* <small className="fw-normal mt-2 mt-lg-0">Showing 1 to <b>{pagelimit}</b> of <b>{totalPosts}</b> entries.</small> */}
          <div className="d-flex flex-wrap gap-3">
            <Button
              variant="secondary"
              disabled={selectedRowData.length === 0 || users.length === 0}
              onClick={handleCreateGroup}
            >
              Create Group
            </Button>

            <Button
              variant="secondary"
              disabled={groups.length === 0}
              onClick={() => setShowModal(true)}
            >
              Submit Groups
            </Button>
          </div>
        </Card.Footer>
      </Card>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Assign Percentage to Groups</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={gotError}>
            {groups.map((group, index) => {
              const key = `group${index + 1}`;
              const value = groupPercentages[key] || "";
              return (
                <Form.Group className="mb-3" key={key}>
                  <Form.Label>
                    {key.toUpperCase()} (SMSC count: {group[key].length})
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter %"
                    min="0"
                    max="100"
                    title="Total % across all groups for the same MCC+MNC+Country combo must equal 100"
                    value={value}
                    onChange={(e) => {
                      const updated = {
                        ...groupPercentages,
                        [key]: parseFloat(e.target.value || 0),
                      };
                      setGroupPercentages(updated);
                    }}
                  />
                  {gotError && !value && (
                    <div className="invalid-feedback d-block">
                      Enter a valid percentage.
                    </div>
                  )}
                </Form.Group>
              );
            })}

            <div className="d-flex justify-content-between my-3">
              <strong>Total:</strong>
              <strong>
                {Object.values(groupPercentages).reduce(
                  (acc, val) => acc + Number(val),
                  0
                )}
                %
              </strong>
            </div>
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group id="username">
                  <Form.Label>Margin</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter margin"
                    value={margin}
                    onChange={(e) => setMargin(e.target.value)} // <- Fix here
                    name="margin"
                    title="Margin must be a number between 0–100"
                  />
                  {gotError && !margin && (
                    <div className="invalid-feedback d-block">
                      Enter a valid margin.
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            type="button"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="secondary"
            disabled={
              Object.values(groupPercentages).reduce(
                (acc, val) => acc + Number(val),
                0
              ) !== 100
            }
            onClick={handleCreateRoute}
          >
            Confirm & Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

//on SMSCRegistrationList
export const SMSCRegistrationListTable = ({ handleEdit }) => {
  const [tableData, setTableData] = useState([]);
  // const [users, setUsers] = useState([]);

  const [searchValue, setSearchValue] = useState("");
  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);

  // Get the usertype from localStorage
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);

  const [getSMSCList] = useGetRegisteredSMSCAccountsMutation();
  const [deleteListApi] = useDeleteSmscAccountMutation();
  // const [approve] = useApproveUserMutation();
  const [download] = useDnldSMSCAccountsDataMutation();

  // Sorting state
  const [sortField, setSortField] = useState("");
  const [sortDirection, setSortDirection] = useState("");

  // Sort function for Enterprise Name
  const handleSort = (field) => {
    if (sortField !== field) {
      // user clicked a new column → always start with ASC
      setSortField(field);
      setSortDirection("ASC");
    } else {
      // user clicked the same column → cycle ASC → DESC → none
      if (sortDirection === "") {
        setSortDirection("ASC");
      } else if (sortDirection === "ASC") {
        setSortDirection("DESC");
      } else if (sortDirection === "DESC") {
        setSortDirection("");
      }
    }
  };

  const fetchTableData = async () => {
    getSMSCList({
      pageNumber: currentPage,
      search: searchValue,
      limit: pagelimit,
      sortBy: sortField,
      sortOrder: sortDirection,
    })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setTableData(response?.data?.data?.items || []);
          setTotalPosts(response?.data?.data?.totalRecords || 0);
          setTotalPages(
            Math.ceil(response?.data?.data?.totalRecords / pagelimit)
          );
        } else {
          setTableData([]);
          setTotalPages(0);
          setTotalPosts(0);
          console.error("Failed to fetch user data");
        }
      })
      .catch((error) => {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
        console.error("Error fetching user data", error);
      });
  };
  const [debouncedValue, setDebouncedValue] = useState("");

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 1000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  useEffect(() => {
    fetchTableData();
  }, [debouncedValue, pagelimit, currentPage, sortField, sortDirection]);

  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // const handleReject = async (row) => {
  //   // Implement your remove logic here

  //   const textMessage = "Are you sure you want to reject this user?";

  //   const result = await SwalWithBootstrapButtons.fire({
  //     icon: "error",
  //     title: "Confirm Rejection",
  //     text: textMessage,
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "Cancel",
  //   });

  //   if (result.isConfirmed) {
  //     //127.0.0.1:7000
  //     try {
  //       const response = await approve({ user_id: row.id, approved: false });
  //       if (response?.data?.statusCode === 200) {
  //         const confirmMessage = "The user has been rejected successfully.";
  //         SwalWithBootstrapButtons.fire("Rejected", confirmMessage, "error");
  //         // Refetch data here
  //         fetchTableData();
  //       } else {
  //         const confirmMessage = "Failed to approve user";
  //         SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
  //       }
  //     } catch (error) {
  //       console.error("Error approving user", error);
  //       const confirmMessage = "An error occurred while approving the user.";
  //       SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
  //     }
  //   }
  // };

  // const handleApprove = async (row) => {
  //   const textMessage = "Are you sure you want to approve this user?";

  //   const result = await SwalWithBootstrapButtons.fire({
  //     icon: "warning",
  //     title: "Confirm Approval",
  //     text: textMessage,
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "Cancel",
  //   });

  //   if (result.isConfirmed) {
  //     try {
  //       const response = await approve({ user_id: row.id, approved: true });
  //       if (response?.data?.statusCode === 200) {
  //         const confirmMessage = "The user has been approved successfully.";
  //         SwalWithBootstrapButtons.fire("Approved", confirmMessage, "success");
  //         // Refetch data here
  //         fetchTableData();
  //       } else {
  //         const confirmMessage = "Failed to approve user";
  //         SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
  //       }
  //     } catch (error) {
  //       console.error("Error approving user", error);
  //       const confirmMessage = "An error occurred while approving the user.";
  //       SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
  //     }
  //   }
  // };

  const handleDelete = async (ids) => {
    const textMessage = "Are you sure you want to delete this List?";
    const result = await SwalWithBootstrapButtons.fire({
      icon: "question",
      title: "Confirm deletion",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });
    if (result.isConfirmed) {
      deleteListApi({ smsc_id: ids })
        .then(async (response) => {
          if (response?.data?.statusCode === 200) {
            await SwalWithBootstrapButtons.fire(
              "Deleted",
              "The Account has been deleted.",
              "success"
            );
            fetchTableData();
          } else {
            await SwalWithBootstrapButtons.fire(
              "Failed",
              "Failed to Delete.",
              "error"
            );
          }
        })
        .catch(async (err) => {
          const errMsg = err?.message || "Error deleting this Account.";
          await SwalWithBootstrapButtons.fire("Failed", errMsg, "error");
        });
    }
  };

  const canEdit = hasPermission("SMSC Registration", "edit");
  const canDownload = hasPermission("SMSC Registration", "download");
  const canDelete = hasPermission("SMSC Registration", "delete");

  const handleDownload = async () => {
    try {
      const blob = await download({
        search: searchValue,
        loggedin_user_id: userObject.id,
        user_type_id: userObject.user_type_id || "1",
      }).unwrap();
      downloadBlobFile(blob, "SMSC_Accounts.csv");
    } catch (err) {
      if (err?.status === 404) alert("No Data for Download!");
      else alert("Download failed.");
    }
  };

  const TableRow = (props) => {
    const { index } = props;

    return (
      <tr className="border-bottom" key={index}>
        <td title={props["smsc-id"] || "-"}>
          <span className="fw-normal">{props["smsc-id"] || "-"}</span>
        </td>
        <td title={props.vendor_name || "-"}>
          <span className="fw-normal">{props.vendor_name || "-"}</span>
        </td>
        <td title={props.smsc_type || "-"}>
          <span className="fw-normal">{props.smsc_type || "-"}</span>
        </td>
        <td title={props["alt-charset"] || "-"}>
          <span className="fw-normal">{props["alt-charset"] || "-"}</span>
        </td>
        <td title={props["transceiver-mode"] || "-"}>
          <span className="fw-normal">{props["transceiver-mode"] || "-"}</span>
        </td>
        <td title={props.host || "-"}>
          <span className="fw-normal">{props.host || "-"}</span>
        </td>
        <td title={props.port || "-"}>
          <span className="fw-normal">{props.port || "-"}</span>
        </td>
        <td title={props["smsc-username"] || "-"}>
          <span className="fw-normal">{props["smsc-username"] || "-"}</span>
        </td>
        <td title={props["system-type"] || "-"}>
          <span className="fw-normal">{props["system-type"] || "-"}</span>
        </td>
        <td title={props["source-addr-ton"] || "-"}>
          <span className="fw-normal">{props["source-addr-ton"] || "-"}</span>
        </td>
        <td title={props["source-addr-npi"] || "-"}>
          <span className="fw-normal">{props["source-addr-npi"] || "-"}</span>
        </td>
        <td title={props["dest-addr-ton"] || "-"}>
          <span className="fw-normal">{props["dest-addr-ton"] || "-"}</span>
        </td>
        <td title={props["dest-addr-npi"] || "-"}>
          <span className="fw-normal">{props["dest-addr-npi"] || "-"}</span>
        </td>
        <td title={props.throughput || "-"}>
          <span className="fw-normal">{props.throughput || "-"}</span>
        </td>
        <td title={props.instances || "-"}>
          <span className="fw-normal">{props.instances || "-"}</span>
        </td>
        {(canDelete || canEdit) && (
          <td>
            {canEdit && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip className="m-0">Edit</Tooltip>}
              >
                <Card.Link
                  className="ms-2 ms-auto"
                  onClick={() => handleEdit(props)}
                >
                  <TbEdit className="icon icon-xxs text-info" />
                </Card.Link>
              </OverlayTrigger>
            )}
            {canDelete && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip className="m-0">Delete</Tooltip>}
              >
                <Card.Link
                  className="ms-2"
                  onClick={() => handleDelete(props["smsc-id"])}
                >
                  <XCircleIcon className="icon icon-xxs text-danger" />
                </Card.Link>
              </OverlayTrigger>
            )}
          </td>
        )}
        {/* <td className="d-flex">
          {(user === 'super_admin' || user === 'admin') && props.status === 'pending' && <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle as={Button} split variant="link" className="text-dark m-0 p-0">
              <DotsHorizontalIcon className="icon icon-xs" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="dashboard-dropdown dropdown-menu-start py-1">
              <Dropdown.Item className="d-flex align-items-center" onClick={() => handleApprove(props)}>
                <CheckIcon className="dropdown-icon text-success me-2" />
                Approve
              </Dropdown.Item>
              {(userType === 'super_admin' || 'admin') &&
                <Dropdown.Item className="d-flex align-items-center" onClick={() => handleReject(props)}>
                  <XIcon className="dropdown-icon text-danger me-2" />
                  Reject
                </Dropdown.Item>}
            </Dropdown.Menu>
          </Dropdown>}
        </td> */}
      </tr>
    );
  };

  return (
    <Fragment>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
        {/* Search Input */}
        <InputGroup className="fmxw-500">
          <InputGroup.Text>
            <SearchIcon className="icon icon-xs" />
          </InputGroup.Text>
          <Form.Control
            type="search"
            placeholder="Search SMSC-ID/SMSC-Username"
            value={searchValue}
            onChange={changeSearchValue}
          />
        </InputGroup>
        <div className="ms-auto d-flex">
          {canEdit && (
            <Button
              variant="secondary"
              className="me-2 d-flex align-items-center"
              as={Link}
              to={Routes.CreateSMSC.path}
            >
              <PlusIcon className="icon icon-xs me-2" /> Add SMSC
            </Button>
          )}

          {canDownload && (
            <Button
              variant="outline-gray-300" /* className="ms-auto d-inline-flex mb-3 me-2 position-relative" style={{ left: '10%' }} */
              onClick={handleDownload}
              className="p-2 me-2"
            >
              <DownloadIcon className="icon icon-sm" />
            </Button>
          )}

          <Dropdown>
            <Dropdown.Toggle
              split
              as={Button}
              variant="outline-gray-300"
              className="text-dark m-0 p-2"
            >
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
              <span className="small ps-2 fw-bold text-dark">Rows per page</span>
              {[10, 20, 30].map((limit) => (
                <Dropdown.Item
                  key={limit}
                  className={`d-flex align-items-center fw-bold ${
                    limit === 30 ? "rounded-bottom" : ""
                  }`}
                  onClick={() => {
                    setPagelimit(limit); // Update the page limit
                    setCurrentPage(1); // Reset the page number to 1
                  }}
                >
                  {limit}{" "}
                  {pagelimit === limit && (
                    <CheckIcon className="icon icon-xxs ms-auto" />
                  )}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            hover
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-bottom">SMSC ID</th>
                <th
                  className="border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("vendor_name")}
                >
                  <div className="d-flex align-items-center">
                    Vendor
                    <div className="ms-1">
                      {sortField === "vendor_name" ? (
                        sortDirection === "ASC" ? (
                          <ArrowNarrowUpIcon
                            className="icon icon-xxs"
                            title="Sort: Ascending"
                          />
                        ) : sortDirection === "DESC" ? (
                          <ArrowNarrowDownIcon
                            className="icon icon-xxs"
                            title="Sort: Descending"
                          />
                        ) : (
                          <TbArrowsSort
                            className="icon icon-xxs"
                            title="Sort: Initial"
                          />
                        )
                      ) : (
                        <TbArrowsSort
                          className="icon icon-xxs"
                          title="Sort: Initial"
                        />
                      )}
                    </div>
                  </div>
                </th>
                <th className="border-bottom">SMS Type</th>
                <th className="border-bottom">ALT-Charset</th>
                <th className="border-bottom">Transceiver Mode</th>
                <th className="border-bottom">Host</th>
                <th className="border-bottom">Port</th>
                <th
                  className="border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("smsc-username")}
                >
                  <div className="d-flex align-items-center">
                    SMSC-Username
                    <div className="ms-1">
                      {sortField === "smsc-username" ? (
                        sortDirection === "ASC" ? (
                          <ArrowNarrowUpIcon
                            className="icon icon-xxs"
                            title="Sort: Ascending"
                          />
                        ) : sortDirection === "DESC" ? (
                          <ArrowNarrowDownIcon
                            className="icon icon-xxs"
                            title="Sort: Descending"
                          />
                        ) : (
                          <TbArrowsSort
                            className="icon icon-xxs"
                            title="Sort: Initial"
                          />
                        )
                      ) : (
                        <TbArrowsSort
                          className="icon icon-xxs"
                          title="Sort: Initial"
                        />
                      )}
                    </div>
                  </div>
                </th>
                <th className="border-bottom">System Type</th>
                <th className="border-bottom">Source-addr-ton</th>
                <th className="border-bottom">Source-addr-api</th>
                <th className="border-bottom">Dest-addr-ton</th>
                <th className="border-bottom">Dest-addr-npi</th>
                <th className="border-bottom">Throughput</th>
                <th className="border-bottom">Instances</th>
                {(canEdit || canDelete) && (
                  <th className="border-bottom">Action</th>
                )}
              </tr>
            </thead>
            <tbody className="border-0">
              {tableData.length > 0 ? (
                tableData.map((u, index) => (
                  <TableRow key={index + 1} index={index + 1} {...u} />
                ))
              ) : (
                <tr>
                  <td colSpan="17" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      <Card.Footer className="p-0 mt-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage - 1)}
              >
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage + 1)}
              >
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </Nav>
        <small className="fw-normal small mt-2 mt-md-0">
          Showing{" "}
          <b>
            {totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-
            {pagelimit * currentPage > totalPosts
              ? totalPosts
              : pagelimit * currentPage}
          </b>{" "}
          of <b>{totalPosts}</b> entries.
        </small>
      </Card.Footer>
    </Fragment>
  );
};

export const SMSCRateManagementListTable = ({ handleEdit }) => {
  const [users, setUsers] = useState([]);
  const [tableData, setTableData] = useState([]);
  // const [allTableData, setAllTableData] = useState([]);
  const [crmValue, setCrmValue] = useState();
  const [statusValue, setStatusValue] = useState();

  const [searchValue, setSearchValue] = useState("");

  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPosts, setTotalPosts] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [userType, setUserType] = useState("");
  // const [status, setStatus] = useState("");

  // Get the usertype from localStorage
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const user = userObject.user_type;

  // const disabledBulkMenu = users.filter((u) => u.isSelected).length === 0;
  // const selectedUsersIds = users.filter((u) => u.isSelected).map((u) => u.id);
  // const totalUsers = users.length;
  // const allSelected = selectedUsersIds.length === totalUsers;
  // const selectUserTypeOptions = [
  //   { value: "2", label: "Admin" },
  //   { value: "3", label: "Customer Relationship Manager" },
  //   { value: "4", label: "Enterprise" },
  //   { value: "5", label: "Biiling Ops" },
  //   { value: "6", label: "Reporting User" },
  // ];

  // const selectStatusTypeOptions = [
  //   { value: "approved", label: "Approved" },
  //   { value: "rejected", label: "Rejected" },
  // ];

  const [enterprise, setEnterprise] = useState([]);

  const [smsAccountRegisteredApi] = useRegisteredSMSRateManagementMutation();
  const [approve] = useApproveUserMutation();
  const [download] = useDnldSMSCRatesMutation();

  const [userDropDown] = useUserDropDownMutation();

  // Sorting state
  const [sortField, setSortField] = useState("");
  const [sortDirection, setSortDirection] = useState("");

  // Sort function for Enterprise Name
  const handleSort = (field) => {
    if (sortField !== field) {
      // user clicked a new column → always start with ASC
      setSortField(field);
      setSortDirection("ASC");
    } else {
      // user clicked the same column → cycle ASC → DESC → none
      if (sortDirection === "") {
        setSortDirection("ASC");
      } else if (sortDirection === "ASC") {
        setSortDirection("DESC");
      } else if (sortDirection === "DESC") {
        setSortDirection("");
      }
    }
  };

  const fetchUserDropdown = async () => {
    try {
      const response = await userDropDown({ user_type: "4" });
      if (response?.data?.statusCode === 200) {
        const userOptions = response.data.data.user_details.map((user) => ({
          value: user.id,
          label: `${user.user_type.toUpperCase()} : ${user.user_name}`,
        }));
        setEnterprise(userOptions);
      } else {
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };

  useEffect(() => {
    fetchUserDropdown();
  }, []);

  const fetchTableData = async () => {
    smsAccountRegisteredApi({
      // mnc: "",
      // mcc: "",
      // cc: "",
      search: searchValue,
      pageNumber: currentPage,
      limit: pagelimit,
      sortBy: sortField,
      sortOrder: sortDirection,
    })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setTableData(response?.data?.data?.rows || 0);
          // setAllTableData(response?.data?.data)
          setTotalPosts(response?.data?.data?.totalItems || 0);
          setTotalPages(response?.data?.data?.totalPages || 0);
        } else {
          setTableData([]);
          setTotalPages(0);
          setTotalPosts(0);
          console.error("Failed to fetch user data");
        }
      })
      .catch((error) => {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
        console.error("Error fetching user data", error);
      });
  };
  const [debouncedValue, setDebouncedValue] = useState("");

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 1000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  useEffect(() => {
    fetchTableData();
    // eslint-disable-next-line
  }, [
    debouncedValue,
    pagelimit,
    currentPage,
    crmValue,
    userType,
    statusValue,
    userType,
    sortField,
    sortDirection,
  ]);

  useEffect(() => {
    const updatedUsers =
      Array.isArray(tableData) && tableData.length > 0
        ? tableData.map((u) => ({ ...u, isSelected: false, show: true }))
        : [];

    setUsers(updatedUsers);
    // setTotalPage(tableData/pagelimit)
  }, [tableData]);

  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    // if (currentPage < totalPages) {
    setCurrentPage(currentPage + 1);
    // }
  };
  const userTypeMap = {
    1: "Super Admin",
    2: "Admin",
    4: "Enterprise",
    5: "Billing Ops",
    3: "Customer Relationship Manager",
    6: "Reporting User",
  };

  const crmMap = {
    1: "CRM1",
    2: "CRM2",
    3: "CRM3",
    4: "CRM4",
    5: "CRM5",
  };

  const selectUserType = (selectedOption) => {
    if (selectedOption != null) {
      setCrmValue(selectedOption.value);
    } else return setCrmValue("");
  };
  const selectStatusType = (selectedOption) => {
    if (selectedOption != null) {
      setStatusValue(selectedOption.value);
    } else return setStatusValue("");
  };

  const handleReject = async (row) => {
    // Implement your remove logic here

    const textMessage = "Are you sure you want to reject this user?";

    const result = await SwalWithBootstrapButtons.fire({
      icon: "error",
      title: "Confirm Rejection",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      //127.0.0.1:7000
      try {
        const response = await approve({ user_id: row.id, approved: false });
        if (response?.data?.statusCode === 200) {
          const confirmMessage = "The user has been rejected successfully.";
          SwalWithBootstrapButtons.fire("Rejected", confirmMessage, "error");
          // Refetch data here
          fetchTableData();
        } else {
          const confirmMessage = "Failed to approve user";
          SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
        }
      } catch (error) {
        console.error("Error approving user", error);
        const confirmMessage = "An error occurred while approving the user.";
        SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
      }
    }
  };

  const handleApprove = async (row) => {
    const textMessage = "Are you sure you want to approve this user?";

    const result = await SwalWithBootstrapButtons.fire({
      icon: "warning",
      title: "Confirm Approval",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const response = await approve({ user_id: row.id, approved: true });
        if (response?.data?.statusCode === 200) {
          const confirmMessage = "The user has been approved successfully.";
          SwalWithBootstrapButtons.fire("Approved", confirmMessage, "success");
          // Refetch data here
          fetchTableData();
        } else {
          const confirmMessage = "Failed to approve user";
          SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
        }
      } catch (error) {
        console.error("Error approving user", error);
        const confirmMessage = "An error occurred while approving the user.";
        SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
      }
    }
  };
  const deleteUsers = async (ids) => {
    // const usersToBeDeleted = ids;
    // const textMessage = "Are you sure you want to delete this List?";
    // const result = await SwalWithBootstrapButtons.fire({
    //   icon: "success",
    //   title: "Confirm deletion",
    //   text: textMessage,
    //   showCancelButton: true,
    //   confirmButtonText: "Yes",
    //   cancelButtonText: "Cancel"
    // });
    // if (result.isConfirmed) {
    //   const newUsers = tableData.filter(f => !usersToBeDeleted.includes(f.id));
    //   deleteListApi({ id: ids })
    //     .then((response) => {
    //       if (response?.data?.statusCode === 200) {
    //         setMessage('The List has been deleted.')
    //       } else {
    //         setError('Failed to Delete.');
    //       }
    //     })
    //     .catch((error) => {
    //       setError('Error deleting this list.' || error);
    //     });
    //   { error === '' ? await SwalWithBootstrapButtons.fire('Deleted', message, 'success') : await SwalWithBootstrapButtons.fire('Failed', error, 'error') }
    //   setTableData(newUsers);
    // }
  };

  const canEdit = hasPermission("SMSC Rates", "edit");
  const canDownload = hasPermission("SMSC Rates", "download");
  const handleDownload = async () => {
    try {
      const blob = await download({
        search: searchValue,
        loggedin_user_id: userObject.id || "1",
        user_type_id: userObject.user_type_id || "1",
      }).unwrap();
      downloadBlobFile(blob, "SMSC_Rates.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };

  const TableRow = (props) => {
    const { index } = props;

    const profit = (props) => {
      let cp = Number(props.cost_price) || 0;
      let sp = Number(props.sell_cost) || 0;
      return sp - cp;
    };

    return (
      <tr className="border-bottom" key={index}>
        <td>
          <span className="fw-normal" title={props.smsc || "-"}>
            {props.smsc || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.vendor || "-"}>
            {props.vendor}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.country_code || "-"}>
            {props.country_code || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.network || "-"}>
            {props.network || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.mnc || "-"}>
            {props.mnc || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.mcc || "-"}>
            {props.mcc || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.cost_price || "-"}>
            {props.cost_price || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={profit(props)}>
            {profit(props)}
          </span>
        </td>
        {/* <td><span className="fw-normal text-info">{props.sell_cost || "-"}</span></td> */}

        {/* <td className="d-flex">
          {(user === 'super_admin' || user === 'admin') && props.status === 'pending' && <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle as={Button} split variant="link" className="text-dark m-0 p-0">
              <DotsHorizontalIcon className="icon icon-xs" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="dashboard-dropdown dropdown-menu-start py-1">
              <Dropdown.Item className="d-flex align-items-center" onClick={() => handleApprove(props)}>
                <CheckIcon className="dropdown-icon text-success me-2" />
                Approve
              </Dropdown.Item>
              {(userType === 'super_admin' || 'admin') &&
                <Dropdown.Item className="d-flex align-items-center" onClick={() => handleReject(props)}>
                  <XIcon className="dropdown-icon text-danger me-2" />
                  Reject
                </Dropdown.Item>}
            </Dropdown.Menu>
          </Dropdown>}
          <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Edit</Tooltip>}>
            <Card.Link className="ms-2 ms-auto" onClick={() => handleEdit(props)}>
              <TbEdit className="icon icon-wide text-info" />
            </Card.Link>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete</Tooltip>}>
            <Card.Link className="ms-2" onClick={() => deleteUsers(props.id)}>
              <XCircleIcon className="icon icon-xs text-danger" />
            </Card.Link>
          </OverlayTrigger>
        </td> */}
      </tr>
    );
  };

  return (
    <Card border={1}>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
        {/* Search Input */}
        <InputGroup className="fmxw-300">
          <InputGroup.Text>
            <SearchIcon className="icon icon-xs" />
          </InputGroup.Text>
          <Form.Control
            type="search"
            placeholder="Search"
            value={searchValue}
            onChange={changeSearchValue}
          />
        </InputGroup>

        {/* Filter by Status */}
        {/* <div className="me-2 me-lg-3 fmxw-300 dataTable-filter">
          <Row className="align-items-center">
            <Col xs="auto" className="ps-0 mb-0">
              <Select
                isClearable
                options={enterprise}
                placeholder="--Select Enterprise--"
                value={status}
                onChange={(selectedOption) => {
                  setStatus(selectedOption);
                  selectStatusType(selectedOption); // your custom handler
                }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    minWidth: '250px',
                    maxWidth: '350px',
                  }),
                  menu: (provided) => ({
                    ...provided,
                    width: 'auto',
                    minWidth: '100%',
                  }),
                }}
              />

            </Col>
          </Row>
        </div> */}

        {/* <div className="me-2 me-lg-3 fmxw-300 dataTable-filter">
          <Row className="align-items-center">
            <Col xs="auto" className="ps-0 mb-0">
              <Select
                isClearable
                options={selectStatusTypeOptions}
                placeholder="--Select Name--"
                value={status}
                onChange={(selectedOption) => { setStatus(selectedOption); selectStatusType(selectedOption); }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    minWidth: '250px', // Set minimum width to handle longer labels
                    maxWidth: '350px', // Set maximum width to prevent it from being too wide
                  }),
                  menu: (provided) => ({
                    ...provided,
                    width: 'auto', // Adjust width based on content
                    minWidth: '100%', // Ensure the dropdown is at least as wide as the select box
                  }),
                }}
              />
            </Col>
          </Row>
        </div> */}

        {/* <div className="me-2 me-lg-3 fmxw-300 dataTable-filter">
          <Row className="align-items-center">
            <Col xs="auto" className="ps-0 mb-0">
              <Select
                isClearable
                options={selectUserTypeOptions}
                placeholder="--Select User Type--"
                value={userType}
                onChange={(selectedOption) => {
                  setUserType(selectedOption);
                  selectUserType(selectedOption);
                }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    minWidth: '200px', // Set minimum width to handle longer labels
                    maxWidth: '250px', // Set maximum width to prevent it from being too wide
                  }),
                  menu: (provided) => ({
                    ...provided,
                    width: 'auto', // Adjust width based on content
                    minWidth: '100%', // Ensure the dropdown is at least as wide as the select box
                  }),
                }}
              />
            </Col>
          </Row>
        </div> */}

        {/* Filter by Status */}
        {/* <div className="me-2 me-lg-3 fmxw-300 dataTable-filter">
          <Row className="align-items-center">
            <Col xs="auto" className="ps-0 mb-0">
              <Select
                isClearable
                options={selectStatusTypeOptions}
                placeholder="--Select Status--"
                value={status}
                onChange={(selectedOption) => { setStatus(selectedOption); selectStatusType(selectedOption); }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    minWidth: '200px', // Set minimum width to handle longer labels
                    maxWidth: '250px', // Set maximum width to prevent it from being too wide
                  }),
                  menu: (provided) => ({
                    ...provided,
                    width: 'auto', // Adjust width based on content
                    minWidth: '100%', // Ensure the dropdown is at least as wide as the select box
                  }),
                }}
              />
            </Col>
          </Row>
        </div> */}
        <div className="ms-auto d-flex gap-2">
          {canEdit && (
            <Button
              variant="secondary"
              className="d-flex align-items-center"
              as={Link}
              to={Routes.CreateSMSCRateManagement.path}
            >
              <PlusIcon className="icon icon-xs me-2" /> Add SMSC Rate
            </Button>
          )}

          {canDownload && (
            <Button
              variant="outline-gray-300" /* className="ms-auto d-inline-flex mb-3 me-2 position-relative" style={{ left: '10%' }} */
              onClick={handleDownload}
              className="p-2"
            >
              <DownloadIcon className="icon icon-sm" />
            </Button>
          )}

          <Dropdown>
            <Dropdown.Toggle
              split
              as={Button}
              variant="outline-gray-300"
              className="text-dark m-0 p-2"
            >
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
              <span className="small ps-2 fw-bold text-dark">Rows per page</span>
              {[10, 20, 30].map((limit) => (
                <Dropdown.Item
                  key={limit}
                  className={`d-flex align-items-center fw-bold ${
                    limit === 30 ? "rounded-bottom" : ""
                  }`}
                  onClick={() => {
                    setPagelimit(limit); // Update the page limit
                    setCurrentPage(1); // Reset the page number to 1
                  }}
                >
                  {limit}{" "}
                  {pagelimit === limit && (
                    <CheckIcon className="icon icon-xxs ms-auto" />
                  )}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-bottom">SMSC ID</th>
                <th
                  className="border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("vendor")}
                >
                  <div className="d-flex align-items-center">
                    Vendor
                    <div className="ms-1">
                      {sortField === "vendor" ? (
                        sortDirection === "ASC" ? (
                          <ArrowNarrowUpIcon
                            className="icon icon-xxs"
                            title="Sort: Ascending"
                          />
                        ) : sortDirection === "DESC" ? (
                          <ArrowNarrowDownIcon
                            className="icon icon-xxs"
                            title="Sort: Descending"
                          />
                        ) : (
                          <TbArrowsSort
                            className="icon icon-xxs"
                            title="Sort: Initial"
                          />
                        )
                      ) : (
                        <TbArrowsSort
                          className="icon icon-xxs"
                          title="Sort: Initial"
                        />
                      )}
                    </div>
                  </div>
                </th>
                <th className="border-bottom">Country Code</th>
                <th
                  className="border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("network")}
                >
                  <div className="d-flex align-items-center">
                    Network
                    <div className="ms-1">
                      {sortField === "network" ? (
                        sortDirection === "ASC" ? (
                          <ArrowNarrowUpIcon
                            className="icon icon-xxs"
                            title="Sort: Ascending"
                          />
                        ) : sortDirection === "DESC" ? (
                          <ArrowNarrowDownIcon
                            className="icon icon-xxs"
                            title="Sort: Descending"
                          />
                        ) : (
                          <TbArrowsSort
                            className="icon icon-xxs"
                            title="Sort: Initial"
                          />
                        )
                      ) : (
                        <TbArrowsSort
                          className="icon icon-xxs"
                          title="Sort: Initial"
                        />
                      )}
                    </div>
                  </div>
                </th>
                <th className="border-bottom">MNC</th>
                <th className="border-bottom">MCC</th>
                <th className="border-bottom">Cost Price</th>
                <th className="border-bottom">Profit</th>
                {/* <th className="border-bottom">Action</th> */}
              </tr>
            </thead>
            <tbody className="border-0">
              {users.length > 0 ? (
                users.map((u, index) => (
                  <TableRow key={index + 1} index={index + 1} {...u} />
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      <Card.Footer className="p-0 mt-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage - 1)}
              >
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage + 1)}
              >
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </Nav>
        <small className="fw-normal small mt-2 mt-md-0">
          Showing{" "}
          <b>
            {totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-
            {pagelimit * currentPage > totalPosts
              ? totalPosts
              : pagelimit * currentPage}
          </b>{" "}
          of <b>{totalPosts}</b> entries.
        </small>
      </Card.Footer>
    </Card>
  );
};
// Enterprise Wallet
export const WalletTable = ({ handleEdit }) => {
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const userID = userObject.id;

  const [users, setUsers] = useState([]);
  const [tableData, setTableData] = useState([]);

  const [searchValue, setSearchValue] = useState("");
  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);

  // const [userType, setUserType] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");

  const disabledBulkMenu = users.filter((u) => u.isSelected).length === 0;
  const selectedUsersIds = users.filter((u) => u.isSelected).map((u) => u.id);
  const totalUsers = users.length;
  const allSelected = selectedUsersIds.length === totalUsers;
  const selectUserTypeOptions = [
    { value: "", label: "All" },
    { value: "1", label: "Admin" },
    { value: "2", label: "Enterprise" },
    { value: "3", label: "Reseller" },
    { value: "4", label: "Biiling Ops" },
    { value: "5", label: "Customer Relationship Manager" },
    { value: "7", label: "Reporting User" },
  ];
  const selectStatusTypeOptions = [
    { value: "", label: "All" },
    { value: "1", label: "Approved" },
    { value: "2", label: "Pending" },
  ];

  const [status, setStatus] = useState(selectStatusTypeOptions[0]);

  const [transactions] = useTransactionalListMutation();
  const [approve] = useApproveUserMutation();
  const [download] = useDnldEntWalletMutation();

  const [debouncedValue, setDebouncedValue] = useState("");

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 1000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  useEffect(() => {
    fetchTableData();
  }, [currentPage, pagelimit, debouncedValue, start, end]);

  const fetchTableData = async () => {
    transactions({
      page: currentPage,
      limit: pagelimit,
      user_id: userObject.user_type === "super_admin" ? "" : userID,
      search: searchValue,
      startDate: start ? start.format("YYYY-MM-DD") : "",
      endDate: end ? end.format("YYYY-MM-DD") : "",
    })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setTableData(response?.data?.data.transactions || []);
          setTotalPages(response?.data?.data?.totalPages || 0);
          setTotalPosts(response?.data?.data?.totalRecords || 0);
        } else {
          setTableData([]);
          setTotalPages(0);
          setTotalPosts(0);
          console.error("Failed to fetch user data");
        }
      })
      .catch((error) => {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
        console.error("Error fetching user data", error);
      });
  };

  useEffect(() => {
    const updatedUsers = tableData.map((u) => ({
      ...u,
      isSelected: false,
      show: true,
    }));

    setUsers(updatedUsers);
    // setTotalPage(tableData/pagelimit)
  }, [tableData]);

  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    // if (currentPage < totalPages) {
    setCurrentPage(currentPage + 1);
    // }
  };

  // const selectUserType = (selectedOption) => {
  //   setCrmValue(selectedOption.value)
  // };

  const canDownload = hasPermission("Enterprise Wallet", "download");
  const handleDownload = async () => {
    try {
      const blob = await download({
        search: searchValue,
        user_id: userID,
        user_type_id: userObject.usertype_id || "1",
        loggedin_user_id: userObject.id,
        user_type_id: userObject.user_type_id,
      }).unwrap();
      downloadBlobFile(blob, "Enterprise_Wallet.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };

  const TableRow = (props) => {
    const { index, isSelected } = props;

    const handleApprove = async (row) => {
      const textMessage = "Are you sure you want to approve this user?";

      const result = await SwalWithBootstrapButtons.fire({
        icon: "warning",
        title: "Confirm Approval",
        text: textMessage,
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
        try {
          const response = await approve({ user_id: row.id });
          if (response?.data?.statusCode === 200) {
            const confirmMessage = "The user has been approved successfully.";
            SwalWithBootstrapButtons.fire(
              "Approved",
              confirmMessage,
              "success"
            );
            // Refetch data here
            fetchTableData();
          } else {
            const confirmMessage = "Failed to approve user";
            SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
          }
        } catch (error) {
          console.error("Error approving user", error);
          const confirmMessage = "An error occurred while approving the user.";
          SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
        }
      }
    };

    return (
      <tr className="border-bottom" key={index}>
        <td>
          <span className="fw-normal" title={props?.user_name || "-"}>
            {props?.user_name}
          </span>
        </td>
        <td>
          <span
            className="fw-normal"
            title={moment(props.createdAt).format("DD/MM/YYYY") || "-"}
          >
            {moment(props.createdAt).format("DD/MM/YYYY")}
          </span>
        </td>
        <td>
          <span
            className="fw-normal"
            title={props.credit ? `+${props.amount}` : `-${props.amount}`}
          >
            {props.credit ? `+${props.amount}` : `-${props.amount}`}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.transaction_by || "-"}>
            {props.transaction_by ? props.transaction_by : "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.remarks || "-"}>
            {props.remarks ? props.remarks : "-"}
          </span>
        </td>
        <td>
          <span
            title={props.status || "-"}
            className={`fw-normal ${
              props.status === "completed"
                ? "text-success"
                : props.status === "pending"
                ? "text-warning"
                : props.status === "rejected"
                ? "text-danger"
                : "text-muted"
            }`}
          >
            {props.status === "completed"
              ? "Completed"
              : props.status === "pending"
              ? "Pending"
              : props.status === "rejected"
              ? "Rejected"
              : "Unknown"}
          </span>
        </td>

        {/* {
          localStorage.getItem('userType') !== 'customer relationship manager' && props.status === 'completed' && <td>-</td>
        } */}
      </tr>
    );
  };

  const handleReject = (row) => {
    // Implement your remove logic here
  };

  return (
    <Card border={1}>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
        {/* Search Input */}
        <InputGroup className="fmxw-300">
          <InputGroup.Text>
            <SearchIcon className="icon icon-xs" />
          </InputGroup.Text>
          <Form.Control
            type="search"
            placeholder={
              userObject.user_type === "enterprise"
                ? "Search Enterprise User"
                : "Search Enterprise"
            }
            value={searchValue}
            onChange={changeSearchValue}
          />
        </InputGroup>

     <Form.Group id="DateRange">
                      <InputGroup className="d-flex flex-nowrap">
                        <InputGroup.Text
                          onClick={() => {
                            setStart(null);
                            setEnd(null);
                          }}
                        >
                          {start || end ? (
                            <XCircleIcon className="icon icon-xs" />
                          ) : (
                            <CalendarIcon className="icon icon-xs" />
                          )}
                        </InputGroup.Text>
                        <Datetime
                          timeFormat={false}
                          onChange={(date) => {
                            if (moment.isMoment(date)) {
                              setStart(date);
                            }
                          }}
                          closeOnSelect={true}
                          renderInput={(props, openCalendar) => (
                            <Form.Control
                              type="search"
                              placeholder="Start Date"
                              value={
                                start ? moment(start).format("DD/MM/YYYY") : ""
                              }
                              onFocus={openCalendar}
                              readOnly
                              style={{ width: "150px", borderRadius: "0" }}
                            />
                          )}
                        />
                        <Datetime
                          timeFormat={false}
                          onChange={(date) => {
                            if (moment.isMoment(date)) {
                              setEnd(date);
                            }
                          }}
                          closeOnSelect={true}
                          isValidDate={(currDate) => currDate.isAfter(start)}
                          initialViewDate={end}
                          renderInput={(props, openCalendar) => (
                            <Form.Control
                              type="search"
                              placeholder="End Date"
                              value={end ? moment(end).format("DD/MM/YYYY") : ""}
                              onFocus={openCalendar}
                              readOnly
                              style={{
                                width: "150px",
                                borderTopLeftRadius: "0",
                                borderBottomLeftRadius: "0",
                              }}
                            />
                          )}
                        />
                      </InputGroup>
                    </Form.Group>

        <div className="ms-auto d-inline-flex gap-2">
          {canDownload && (
            <Button
              variant="outline-gray-300"
              className="p-2"
              onClick={handleDownload}
            >
              <DownloadIcon className="icon icon-sm" />
            </Button>
          )}
          <Dropdown>
            <Dropdown.Toggle
              split
              as={Button}
              variant="outline-gray-300"
              className="text-dark m-0 p-2"
            >
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
              <span className="small ps-2 fw-bold text-dark">
                Rows per page
              </span>
              <Dropdown.Item
                className="d-flex align-items-center fw-bold"
                value="10"
                onClick={() => setPagelimit(10)}
              >
                10{" "}
                {pagelimit == 10 && (
                  <CheckIcon className="icon icon-xxs ms-auto" />
                )}
              </Dropdown.Item>
              <Dropdown.Item
                className="d-flex align-items-center fw-bold"
                value="20"
                onClick={() => setPagelimit("20")}
              >
                20{" "}
                {pagelimit == 20 && (
                  <CheckIcon className="icon icon-xxs ms-auto" />
                )}
              </Dropdown.Item>
              <Dropdown.Item
                className="d-flex align-items-center fw-bold rounded-bottom"
                value="30"
                onClick={() => setPagelimit("30")}
              >
                30{" "}
                {pagelimit == 30 && (
                  <CheckIcon className="icon icon-xxs ms-auto" />
                )}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-bottom">
                  {userObject.user_type === "enterprise"
                    ? "Enterprise User"
                    : "Enterprise"}
                </th>
                <th className="border-bottom">Transaction Date</th>
                <th className="border-bottom">Amount</th>
                <th className="border-bottom">Transaction By</th>
                <th className="border-bottom">Remarks</th>
                <th className="border-bottom">Status</th>
                {/* {localStorage.getItem('userType') !== 'customer relationship manager' &&
                  <th className="border-bottom">Action</th>
                } */}
              </tr>
            </thead>
            <tbody className="border-0">
              {users.length > 0 ? (
                users.map((u, index) => (
                  <TableRow key={index + 1} index={index + 1} {...u} />
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <Card.Footer className="p-0 mt-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage - 1)}
              >
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage + 1)}
              >
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </Nav>
        <small className="fw-normal small mt-2 mt-md-0">
          Showing{" "}
          <b>
            {totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-
            {pagelimit * currentPage > totalPosts
              ? totalPosts
              : pagelimit * currentPage}
          </b>{" "}
          of <b>{totalPosts}</b> entries.
        </small>
      </Card.Footer>
    </Card>
  );
};

// Vendor Wallet
export const VendorWalletTable = ({ handleEdit }) => {
  // Get the user type from localStorage :: UI
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);

  const [users, setUsers] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [crmValue, setCrmValue] = useState();

  const [searchValue, setSearchValue] = useState("");
  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);

  const [userType, setUserType] = useState("");
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const disabledBulkMenu = users.filter((u) => u.isSelected).length === 0;
  const selectedUsersIds = users.filter((u) => u.isSelected).map((u) => u.id);
  const totalUsers = users.length;
  const allSelected = selectedUsersIds.length === totalUsers;
  const selectUserTypeOptions = [
    { value: "1", label: "Admin" },
    { value: "2", label: "Enterprise" },
    { value: "3", label: "Reseller" },
    { value: "4", label: "Biiling Ops" },
    { value: "5", label: "Customer Relationship Manager" },
    { value: "7", label: "Reporting User" },
  ];
  const selectStatusTypeOptions = [
    { value: "1", label: "Approved" },
    { value: "2", label: "Pending" },
  ];

  const [status, setStatus] = useState(selectStatusTypeOptions[0]);

  const [transactions] = useGetVendorTableMutation();
  const [approve] = useApproveUserMutation();
  const [download] = useDnldVendorWalletMutation();

  const [debouncedValue, setDebouncedValue] = useState("");

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 1000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  useEffect(() => {
    fetchTableData();
  }, [currentPage, pagelimit, debouncedValue, start, end]);

  const fetchTableData = async () => {
    transactions({
      page: currentPage,
      limit: pagelimit,
      vendor: searchValue,
      startDate: start ? start.format("YYYY-MM-DD") : "",
      endDate: end ? end.format("YYYY-MM-DD") : "",
    })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setTableData(response?.data?.data?.queryData || []);
          setTotalPages(response?.data?.data?.totalPages || 0);
          setTotalPosts(response?.data?.data?.totalItems || 0);
        } else {
          setTableData([]);
          setTotalPages(0);
          setTotalPosts(0);
          console.error("Failed to fetch user data");
        }
      })
      .catch((error) => {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
        console.error("Error fetching user data", error);
      });
  };

  useEffect(() => {
    const updatedUsers = tableData.map((u) => ({
      ...u,
      isSelected: false,
      show: true,
    }));

    setUsers(updatedUsers);
    // setTotalPage(tableData/pagelimit)
  }, [tableData]);

  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    // if (currentPage < totalPages) {
    setCurrentPage(currentPage + 1);
    // }
  };

  const selectUserType = (selectedOption) => {
    setCrmValue(selectedOption.value);
  };

  const canDownload = hasPermission("Vendor Wallet", "download");
  const handleDownload = async () => {
    try {
      const blob = await download({
        // search: searchValue,
        user_id: userObject.id,
        loggedin_user_id: userObject.id,
        user_type_id: userObject.user_type_id,
      }).unwrap();
      downloadBlobFile(blob, "Vendor_Wallet.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };

  const TableRow = (props) => {
    const { index, isSelected } = props;

    const handleApprove = async (row) => {
      const textMessage = "Are you sure you want to approve this user?";

      const result = await SwalWithBootstrapButtons.fire({
        icon: "warning",
        title: "Confirm Approval",
        text: textMessage,
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
        try {
          const response = await approve({ user_id: row.id });
          if (response?.data?.statusCode === 200) {
            const confirmMessage = "The user has been approved successfully.";
            SwalWithBootstrapButtons.fire(
              "Approved",
              confirmMessage,
              "success"
            );
            // Refetch data here
            fetchTableData();
          } else {
            const confirmMessage = "Failed to approve user";
            SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
          }
        } catch (error) {
          console.error("Error approving user", error);
          const confirmMessage = "An error occurred while approving the user.";
          SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
        }
      }
    };

    const handleReject = (row) => {
      // Implement your remove logic here
    };

    return (
      <tr className="border-bottom" key={index}>
        <td>
          <span className="fw-normal" title={props?.vendor_name || "-"}>
            {props?.vendor_name}
          </span>
        </td>
        <td>
          <span
            className="fw-normal"
            title={moment(props.createdAt).format("DD/MM/YYYY") || "-"}
          >
            {moment(props.createdAt).format("DD/MM/YYYY")}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.transaction_type || "-"}>
            {props.transaction_type === "credit"
              ? `+${props.amount}`
              : `-${props.amount}`}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.transaction_by || "-"}>
            {props.transaction_by ? props.transaction_by : "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.remarks || "-"}>
            {props.remarks ? props.remarks : "-"}
          </span>
        </td>
        <td>
          <span
            title={props.status || "-"}
            className={`fw-normal text-capitalize ${
              props.status === "completed"
                ? "text-success"
                : props.status === "pending"
                ? "text-warning"
                : props.status === "rejected"
                ? "text-danger"
                : "text-muted"
            }`}
          >
            {props.status || "-"}
          </span>
        </td>
      </tr>
    );
  };

  return (
    <Card border={1}>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
        {/* Search Input */}
        <InputGroup className="fmxw-300">
          <InputGroup.Text>
            <SearchIcon className="icon icon-xs" />
          </InputGroup.Text>
          <Form.Control
            type="search"
            placeholder="Search Vendor Name"
            value={searchValue}
            onChange={changeSearchValue}
          />
        </InputGroup>

       <Form.Group id="DateRange">
                        <InputGroup className="d-flex flex-nowrap">
                          <InputGroup.Text
                            onClick={() => {
                              setStart(null);
                              setEnd(null);
                            }}
                          >
                            {start || end ? (
                              <XCircleIcon className="icon icon-xs" />
                            ) : (
                              <CalendarIcon className="icon icon-xs" />
                            )}
                          </InputGroup.Text>
                          <Datetime
                            timeFormat={false}
                            onChange={(date) => {
                              if (moment.isMoment(date)) {
                                setStart(date);
                              }
                            }}
                            closeOnSelect={true}
                            renderInput={(props, openCalendar) => (
                              <Form.Control
                                type="search"
                                placeholder="Start Date"
                                value={
                                  start ? moment(start).format("DD/MM/YYYY") : ""
                                }
                                onFocus={openCalendar}
                                readOnly
                                style={{ width: "150px", borderRadius: "0" }}
                              />
                            )}
                          />
                          <Datetime
                            timeFormat={false}
                            onChange={(date) => {
                              if (moment.isMoment(date)) {
                                setEnd(date);
                              }
                            }}
                            closeOnSelect={true}
                            isValidDate={(currDate) => currDate.isAfter(start)}
                            initialViewDate={end}
                            renderInput={(props, openCalendar) => (
                              <Form.Control
                                type="search"
                                placeholder="End Date"
                                value={end ? moment(end).format("DD/MM/YYYY") : ""}
                                onFocus={openCalendar}
                                readOnly
                                style={{
                                  width: "150px",
                                  borderTopLeftRadius: "0",
                                  borderBottomLeftRadius: "0",
                                }}
                              />
                            )}
                          />
                        </InputGroup>
                      </Form.Group>

        <div className="ms-auto d-inline-flex gap-2">
          {canDownload && (
            <Button
              variant="outline-gray-300"
              className="p-2"
              onClick={handleDownload}
            >
              <DownloadIcon className="icon icon-sm" />
            </Button>
          )}
          <Dropdown>
            <Dropdown.Toggle
              split
              as={Button}
              variant="outline-gray-300"
              className="text-dark m-0 p-2"
            >
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
              <span className="small ps-2 fw-bold text-dark">
                Rows per page
              </span>
              <Dropdown.Item
                className="d-flex align-items-center fw-bold"
                value="10"
                onClick={() => setPagelimit(10)}
              >
                10{" "}
                {pagelimit == 10 && (
                  <CheckIcon className="icon icon-xxs ms-auto" />
                )}
              </Dropdown.Item>
              <Dropdown.Item
                className="d-flex align-items-center fw-bold"
                value="20"
                onClick={() => setPagelimit("20")}
              >
                20{" "}
                {pagelimit == 20 && (
                  <CheckIcon className="icon icon-xxs ms-auto" />
                )}
              </Dropdown.Item>
              <Dropdown.Item
                className="d-flex align-items-center fw-bold rounded-bottom"
                value="30"
                onClick={() => setPagelimit("30")}
              >
                30{" "}
                {pagelimit == 30 && (
                  <CheckIcon className="icon icon-xxs ms-auto" />
                )}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-bottom">Vendor Name</th>
                <th className="border-bottom">Transaction Date</th>
                <th className="border-bottom">Amount</th>
                <th className="border-bottom">Transaction By</th>
                <th className="border-bottom">Remarks</th>
                <th className="border-bottom">Status</th>
                {/* {localStorage.getItem('userType') !== 'customer relationship manager' &&
                  <th className="border-bottom">Action</th>
                } */}
              </tr>
            </thead>
            <tbody className="border-0">
              {users.length > 0 ? (
                users.map((u, index) => (
                  <TableRow key={index + 1} index={index + 1} {...u} />
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <Card.Footer className="mt-3 p-0 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage - 1)}
              >
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage + 1)}
              >
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </Nav>
        <small className="fw-normal small mt-2 mt-md-0">
          Showing{" "}
          <b>
            {totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-
            {pagelimit * currentPage > totalPosts
              ? totalPosts
              : pagelimit * currentPage}
          </b>{" "}
          of <b>{totalPosts}</b> entries.
        </small>
      </Card.Footer>
    </Card>
  );
};

// SMS Templates Lists
export const SMSTemplate = () => {
  const [tableData, setTableData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [status, setStatus] = useState("");
  const [category, setCategory] = useState("");
  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);
  const [debouncedValue, setDebouncedValue] = useState("");

  const [templateList] = useGetSMSTemplatesMutation();
  const [blacklist] = useBlacklistSMSTemplatesMutation();
  const [download] = useDnldSMSTemplatesMutation();

  // Get the id from localStorage
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const userType = userObject.user_type;
  const userId = userObject.id;
  const international =
    userObject.country === "Saudi Arabia" || "United Arab Emirates";

  const canDownload = hasPermission("Templates", "download");
  const canEdit = hasPermission("Templates", "edit");

  const handleDownload = async () => {
    try {
      const blob = await download({
        search: searchValue,
        status: status?.value,
        userId: userId,
        category: category?.value,
        user_type_id: userObject.user_type_id,
        associated_enterprise_id: userObject.associated_enterprise_id,
      }).unwrap();
      downloadBlobFile(blob, "SMS_Templates.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };

  const fetchTableData = async () => {
    templateList({
      user_id: userType === "super_admin" || userType === "admin" ? "" : userId,
      page: currentPage,
      limit: pagelimit,
      search: searchValue,
      category: category?.value,
      status: status?.value,
      country: "",
    })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setTableData(response?.data?.data?.result?.data || []);
          setTotalPages(response?.data?.data?.result?.totalPages || 0);
          setTotalPosts(response?.data?.data?.result?.totalPosts || 0);
        } else {
          setTableData([]);
          setTotalPages(0);
          setTotalPosts(0);
        }
      })
      .catch((error) => {
        alert("Error fetching user data in SMS", error);
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      });
  };

  useEffect(() => {
    fetchTableData();
    // eslint-disable-next-line
  }, [debouncedValue, currentPage, pagelimit, status, category]);

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 1000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  const handleRefresh = () => {
    fetchTableData();
  };

  const changeSearchValue = (e) => {
    setSearchValue(e.target.value);
  };

  // const deleteUsers = async (ids) => {
  //   const usersToBeDeleted = ids;
  //   const textMessage = "Are you sure do you want to delete this template?";

  //   const result = await SwalWithBootstrapButtons.fire({
  //     icon: "error",
  //     title: "Confirm deletion",
  //     text: textMessage,
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "Cancel"
  //   });

  //   if (result.isConfirmed) {
  //     const newUsers = tableData.filter(f => !usersToBeDeleted.includes(f.id));
  //     const confirmMessage = "This template has been deleted.";

  //     setTableData(newUsers);
  //     await SwalWithBootstrapButtons.fire('Deleted', confirmMessage, 'success');
  //   }
  // }

  const [confirmMessage, setConfirmMessage] = useState("");
  const blacklistUsers = async (ids) => {
    const textMessage = "Are you sure you want to De-Activate this template?";

    const result = await SwalWithBootstrapButtons.fire({
      icon: "error",
      title: "Confirmation",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      blacklist(ids)
        .then((response) => {
          if (
            response?.data?.statusCode >= 200 &&
            response?.data?.statusCode <= 204
          ) {
            setConfirmMessage(response.data.message);
            SwalWithBootstrapButtons.fire(
              "De-Activated",
              confirmMessage,
              "success"
            );
          } else {
            setConfirmMessage(
              response.message || "Failed to deactivate user SMS template"
            );
            SwalWithBootstrapButtons.fire(
              "Deactivation Failed",
              confirmMessage,
              "error"
            );
          }
        })
        .catch((error) => {
          setConfirmMessage(
            error.message || "Error deactivating user temp in SMS"
          );
          SwalWithBootstrapButtons.fire(
            "Deactivation Failed",
            confirmMessage,
            "error"
          );
        });
    }
    setStatus("");
  };

  const editList = (ids) => {};

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const TooltipContent = ({ header, body }) => {
    if (!body) return <p className="m-0">No Content</p>;

    return (
      <div className="previeSmsTemp">
        <span>
          <FaCircleUser />
          <p className="m-0">{header || "HEADER"}</p>
        </span>
        <p>{body}</p>
      </div>
    );
  };

  const TableRow = (props) => {
    const statusVariant =
      props.status === "Active"
        ? "success"
        : props.status === "Blacklist"
        ? "danger"
        : "primary";

    return (
      <tr className="border-bottom">
        <td>
          <span className="fw-normal" title={props.template_name}>
            {props.template_name || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.category || "-"}>
            {props.category || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.country || "-"}>
            {props.country || "-"}
          </span>
        </td>
        {!international && (
          <td>
            <span className="fw-normal" title={props.header || "-"}>
              {props.header || "-"}
            </span>
          </td>
        )}
        <td>
          <span
            className={`fw-normal text-${statusVariant}`}
            title={props.status || "-"}
          >
            {props.status || "-"}
          </span>
        </td>
        <td>
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip className="m-0">
                <TooltipContent
                  header={props.header}
                  body={props.template_content}
                />
              </Tooltip>
            }
          >
            <Card.Link className="ms-2">
              <TbDeviceMobileMessage className="icon icon-xxs text-info" />
            </Card.Link>
          </OverlayTrigger>
        </td>
        {!international && (
          <td>
            <span className="fw-normal" title={props.template_id || "-"}>
              {props.template_id || "-"}
            </span>
          </td>
        )}
        {!international && (
          <td>
            <span className="fw-normal" title={props.pe_id || "-"}>
              {props.pe_id || "-"}
            </span>
          </td>
        )}
        <td>
          <span
            className="fw-normal"
            title={props.registered_by_user_name || "-"}
          >
            {props.registered_by_user_name || "-"}
          </span>
        </td>
        <td>
          <span
            className="fw-normal"
            title={moment(props.createdAt).format("DD/MM/YYYY") || "-"}
          >
            {moment(props.createdAt).format("DD/MM/YYYY") || "-"}
          </span>
        </td>
        {canEdit && (
          <td>
            {/* <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle as={Button} split variant="link" className="text-dark m-0 p-0">
              <DotsHorizontalIcon className="icon icon-xs" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="dashboard-dropdown dropdown-menu-start py-1">
              <Dropdown.Item className="d-flex align-items-center" onClick={() => deleteUsers(props.sno)}>
                <XCircleIcon className="dropdown-icon text-danger me-2" />
                Delete
              </Dropdown.Item>
              {(userType === 'super_admin' || userType === 'admin') &&
                <Dropdown.Item className="d-flex align-items-center" onClick={() => blacklistUsers(props.template_id)}>
                  <UserRemoveIcon className="dropdown-icon text-danger me-2" />
                  Blacklist
                </Dropdown.Item>}
            </Dropdown.Menu>
          </Dropdown> */}
            {(userType === "super_admin" || userType === "admin") && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip className="m-0">Deactivate</Tooltip>}
              >
                <Card.Link
                  className="ms-2"
                  onClick={() => blacklistUsers(props.template_id)}
                >
                  <MdAppBlocking className="icon icon-xxs text-danger me-2" />
                </Card.Link>
              </OverlayTrigger>
            )}
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip className="m-0">Edit</Tooltip>}
            >
              <Card.Link className="ms-2" onClick={() => editList(props.id)}>
                <TbEdit className="icon icon-xxs text-info" />
              </Card.Link>
            </OverlayTrigger>
          </td>
        )}
      </tr>
    );
  };

  return (
    <Card border={1}>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
        <InputGroup className="fmxw-300 d-flex flex-nowrap">
          <InputGroup.Text>
            <SearchIcon className="icon icon-xs" />
          </InputGroup.Text>
          <Form.Control
            type="search"
            placeholder="Search Template Name/Header"
            value={searchValue}
            onChange={changeSearchValue}
          />
        </InputGroup>
        <div className="fmxw-300">
          <Select
            options={[
              { value: "PROMOTIONAL", label: "Promotional" },
              { value: "TRANSACTIONAL", label: "Transactional" },
              { value: "OTP", label: "OTP" },
            ]}
            value={category}
            onChange={(option) => setCategory(option)}
            isClearable
            placeholder="Select Category"
            styles={{
              container: (provided) => ({
                ...provided,
                minWidth: "210px", // Set minimum width to handle longer labels
                maxWidth: "250px", // Set maximum width to prevent it from being too wide
              }),
              menu: (provided) => ({
                ...provided,
                width: "auto", // Adjust width based on content
                minWidth: "100%", // Ensure the dropdown is at least as wide as the select box
              }),
            }}
          />
        </div>
        <div className="fmxw-300">
          <Select
            options={[
              { value: "Active", label: "Active" },
              { value: "Blacklisted", label: "Blacklisted" },
            ]}
            value={status}
            onChange={(option) => setStatus(option)}
            isClearable
            placeholder="Select Status"
            styles={{
              container: (provided) => ({
                ...provided,
                minWidth: "200px", // Set minimum width to handle longer labels
                maxWidth: "250px", // Set maximum width to prevent it from being too wide
              }),
            }}
          />
        </div>

        <div className="ms-auto d-flex gap-2">
          {userType === "enterprise" && canEdit && (
            <Button
              as={Link}
              to={{
                pathname: Routes.CreateTemplate.path,
                state: { tab: "SMS" },
              }}
              variant="secondary"
              size="sm"
              className="d-inline-flex align-items-center"
            >
              <PlusIcon className="icon icon-xs me-2" /> New Template
            </Button>
          )}

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip className="m-0">Refresh</Tooltip>}
          >
            <Button
              variant="outline-gray-300"
              className="p-2"
              onClick={handleRefresh}
            >
              <MdOutlineRefresh className="icon icon-sm" />
            </Button>
          </OverlayTrigger>

          {canDownload && (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip className="m-0">Download</Tooltip>}
            >
              <Button
                variant="outline-gray-300"
                className="p-2"
                onClick={handleDownload}
              >
                <DownloadIcon className="icon icon-sm" />
              </Button>
            </OverlayTrigger>
          )}

          <Dropdown className="">
            <Dropdown.Toggle
              split
              as={Button}
              variant="outline-gray-300"
              className="text-dark m-0 p-2"
            >
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
              <span className="small ps-2 fw-bold text-dark">Rows per page</span>
              {[10, 20, 30].map((limit) => (
                <Dropdown.Item
                  key={limit}
                  className={`d-flex align-items-center fw-bold ${
                    limit === 30 ? "rounded-bottom" : ""
                  }`}
                  onClick={() => {
                    setPagelimit(limit); // Update the page limit
                    setCurrentPage(1); // Reset the page number to 1
                  }}
                >
                  {limit}{" "}
                  {pagelimit === limit && (
                    <CheckIcon className="icon icon-xxs ms-auto" />
                  )}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-bottom">Template Name</th>
                <th className="border-bottom">Category</th>
                <th className="border-bottom">Country</th>
                {!international && <th className="border-bottom">Header</th>}
                <th className="border-bottom">Status</th>
                <th className="border-bottom">Preview</th>
                {!international && (
                  <th className="border-bottom">Template ID</th>
                )}
                {!international && <th className="border-bottom">PE ID</th>}
                <th className="border-bottom">Registered By</th>
                <th className="border-bottom">Created On</th>
                {canEdit && <th className="border-bottom">Action</th>}
              </tr>
            </thead>
            <tbody className="border-0">
              {tableData.length > 0 ? (
                tableData.map((u, index) => <TableRow key={index} {...u} />)
              ) : (
                <tr>
                  <td colSpan="12" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <Card.Footer className="p-0 mt-3 border-0 d-flex flex-wrap align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage - 1)}
              >
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage + 1)}
              >
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </Nav>
        <small className="fw-normal small mt-2 mt-md-0">
          Showing{" "}
          <b>
            {totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-
            {pagelimit * currentPage > totalPosts
              ? totalPosts
              : pagelimit * currentPage}
          </b>{" "}
          of <b>{totalPosts}</b> entries.
        </small>
      </Card.Footer>
    </Card>
  );
};
// WhatsAPP Templates lists
export const TemplateTable = () => {
  const [tableData, setTableData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [status, setStatus] = useState("");
  const [category, setCategory] = useState("");
  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);
  const [debouncedValue, setDebouncedValue] = useState("");
  // const [preview, setPreview] = useState(false);

  // Get the id from localStorage
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const userType = userObject.user_type;
  const userId = userObject.id;

  const [templateList] = useGetWhatsappTemplatesMutation();

  const fetchTableData = async () => {
    if (!userId || !currentPage || !pagelimit) return;
    try {
      const response = await templateList({
        // user_id: (userType === 'super_admin' || userType === 'admin') ? "" : userId,
        page: currentPage,
        limit: pagelimit,
        templateName: searchValue,
        category: category?.value,
        status: status?.value,
        from: "",
        to: "",
      });

      if (response?.data?.statusCode === 200) {
        setTableData(response?.data?.data?.result?.data || []);
        setTotalPages(response?.data?.data?.result?.totalPages || 0);
        setTotalPosts(response?.data?.data?.result?.totalPosts || 0);
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    } catch (error) {
      setTableData([]);
      setTotalPages(0);
      setTotalPosts(0);
      alert(`Error fetching user data in WhatsApp: ${error.message}`);
    }
  };

  useEffect(() => {
    fetchTableData();
    // eslint-disable-next-line
  }, [
    debouncedValue,
    currentPage,
    userType,
    userId,
    status,
    category,
    pagelimit,
  ]);

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 1000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  const handleRefresh = () => {
    fetchTableData();
  };

  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
  };

  // const deleteUsers = async (ids) => {
  //   const usersToBeDeleted = ids;
  //   // const usersNr = usersToBeDeleted.length;
  //   const textMessage = "Are you sure do you want to delete this template?";

  //   const result = await SwalWithBootstrapButtons.fire({
  //     icon: "error",
  //     title: "Confirm deletion",
  //     text: textMessage,
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "Cancel"
  //   });

  //   if (result.isConfirmed) {
  //     const newUsers = tableData.filter(f => !usersToBeDeleted.includes(f.ids));
  //     const confirmMessage = "This template has been deleted.";

  //     setTableData(newUsers);
  //     await SwalWithBootstrapButtons.fire('Deleted', confirmMessage, 'success');
  //   }
  // }

  const [confirmMessage, setConfirmMessage] = useState("");
  const [deactivate] = useDeactivateWhatsTemplatesMutation();
  const [download] = useDnldWhatsAppTemplatesMutation();

  const blacklistUsers = async (ids) => {
    const textMessage = "Are you sure you want to De-Activate this template?";

    const result = await SwalWithBootstrapButtons.fire({
      icon: "error",
      title: "Confirmation",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      deactivate({ template: ids })
        .then((response) => {
          if (
            response?.data?.statusCode >= 200 &&
            response?.data?.statusCode <= 204
          ) {
            setConfirmMessage(response?.data?.message);
            SwalWithBootstrapButtons.fire(
              "Template deactivated successfully!",
              confirmMessage,
              "success"
            );
          } else {
            setConfirmMessage(
              response?.data?.message ||
                "Failed to Deactivate user SMS template"
            );
            SwalWithBootstrapButtons.fire(
              "Deactivation Failed",
              confirmMessage,
              "error"
            );
          }
        })
        .catch((error) => {
          setConfirmMessage(
            error?.message || "Error Deactivating user temp in SMS"
          );
          SwalWithBootstrapButtons.fire(
            "Deactivation Failed",
            confirmMessage,
            "error"
          );
        });
    }
    setDebouncedValue();
  };

  const editList = (ids) => {};

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // template preview on table
  const TooltipContent = ({ template_components }) => {
    if (!template_components) return <p className="m-0">No Content</p>;

    const { header, body, footer, buttons, cards } = template_components;

    return (
      <div className="previewWhatsTemp">
        {header && Object.keys(header).length > 0 && (
          <div className="w-100">
            {header?.type === "text" && <b>{header.text}</b>}
            {header?.type === "image" && (
              <span className="w-doc">
                <BsImageFill className="icon icon-wide" />
              </span>
            )}
            {header?.type === "video" && (
              <span className="w-doc">
                <MdVideoLibrary className="icon icon-wide" />
              </span>
            )}
            {header?.type === "document" && (
              <span className="w-doc">
                <GrDocumentText />
              </span>
            )}
          </div>
        )}
        {body?.add_security_recommendation ? (
          <span className="wp-body">
            <b>{buttons?.text || "{{1}}"}</b> is your verification code. For
            Your Security, do not share this code.
          </span>
        ) : (
          <p className="wp-body">{body?.text}</p>
        )}

        {footer?.code_expiration_minutes ? (
          <span className="wp-footer">{`This code expires in ${footer?.code_expiration_minutes} minutes.`}</span>
        ) : (
          <span className="wp-footer">{footer?.text}</span>
        )}
        {/* 
        {cards && Object.keys(cards).length > 0 &&
          <span className="wp-carousel">
            <span>
              <BsImageFill className="icon icon-wide" />
              <p className="wp-body">
                {cards.elements[0].body.text}
              </p>
            </span>
          </span>
        } */}

        {buttons && Object.keys(buttons).length > 0 && (
          <div className="wp-btns">
            {buttons.type === "combined_buttons" &&
              buttons.elements.map((row, index) => (
                <p key={index}>
                  {row.type === "dynamic" || row.type === "static" ? (
                    <>
                      <PiArrowSquareUpRight />
                      {row.text}
                    </>
                  ) : row.type === "phone" ? (
                    <>
                      <PiPhone />
                      {row.text}
                    </>
                  ) : (
                    row.text
                  )}
                </p>
              ))}
            {buttons.type === "quick_reply" &&
              buttons.elements.map((row, index) => (
                <p key={index}>{row.text}</p>
              ))}
            {buttons.type === "call_to_action" &&
              buttons.elements.map((row, index) => (
                <p key={index}>
                  {row.type === "static" || row.type === "dynamic" ? (
                    <>
                      <PiArrowSquareUpRight />
                      {row.text}
                    </>
                  ) : (
                    <>
                      <PiPhone />
                      {row.text}
                    </>
                  )}
                </p>
              ))}
            {buttons.type === "OTP" && body?.add_security_recommendation && (
              <p>
                <MdOutlineContentCopy /> Copy Code
              </p>
            )}
          </div>
        )}
      </div>
    );
  };

  const findHeader = (template) => {
    const header = template.find((item) => item.type === "HEADER");
    if (!header) return "-";
    if (header.format === "text") return header.text;
    if (header.format === "image")
      return <BsImageFill className="icon icon-xs" title="image" />;
    if (header.format === "video")
      return <MdVideoLibrary className="icon icon-xs" title="video" />;
    if (header.format === "document")
      return (
        <IoDocumentTextOutline className="icon icon-xs" title="document" />
      );
    return "-";
  };

  const statusOptions = [
    { label: "Approved", value: "APPROVED" },
    { label: "Rejected", value: "REJECTED" },
    { label: "Pending", value: "PENDING" },
  ];

  const canEdit = hasPermission("Templates", "edit");
  const canDownload = hasPermission("Templates", "download");

  const handleDownload = async () => {
    try {
      const blob = await download({
        search: searchValue,
        category: category?.value,
        status: status?.value,
        from: "",
        to: "",
        user_type: userObject.user_type,
        userId: userId,
        user_type_id: userObject.user_type_id,
        associated_enterprise_id: userObject.associated_enterprise_id,
      }).unwrap();
      downloadBlobFile(blob, "WhatsApp_Templates.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };

  const TableRow = (props) => {
    const { index } = props;
    const statusVariant =
      props.status === "APPROVED"
        ? "success"
        : props.status === "PENDING"
        ? "warning"
        : props.status === "deactivate"
        ? "danger"
        : props.status === "REJECTED"
        ? "info"
        : "primary";

    return (
      <tr className="border-bottom" key={index}>
        {/* <td><span className="fw-normal d-flex align-items-center">{index}</span></td> */}
        <td>
          <span
            className="fw-normal"
            style={{ maxWidth: "200px" }}
            title={props.template_name || "-"}
          >
            {props.template_name || "-"}
          </span>
        </td>
        <td>
          <span
            className="fw-normal "
            style={{ maxWidth: "120px" }}
            title={props.template_category || "-"}
          >
            {props.template_category || "-"}
          </span>
        </td>
        <td>
          <span
            className="fw-normal"
            title={findHeader(props.template_components)}
          >
            {findHeader(props.template_components)}
          </span>
        </td>
        <td>
          <span
            className={`fw-normal text-${statusVariant}`}
            title={capitalizeFirstLetter(props.status)}
          >
            {capitalizeFirstLetter(props.status)}
          </span>
        </td>
        <td>
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip className="m-0">
                <TooltipContent template_components={props.format} />
              </Tooltip>
            }
          >
            <Card.Link className="ms-2">
              <TbDeviceMobileMessage className="icon icon-xxs text-info" />
            </Card.Link>
          </OverlayTrigger>
        </td>
        <td>
          <span
            className="fw-normal"
            title={moment(props.created_at).format("DD/MM/YYYY")}
          >
            {moment(props.created_at).format("DD/MM/YYYY")}
          </span>
        </td>
        {canEdit && (
          <td>
            {/* <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle as={Button} split variant="link" className="text-dark m-0 p-0">
              <DotsHorizontalIcon className="icon icon-xs" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="dashboard-dropdown dropdown-menu-start mt-2 py-1">
              <Dropdown.Item className="d-flex align-items-center" onClick={() => deleteUsers(props.sno)}>
                <XCircleIcon className="dropdown-icon text-danger me-2" />
                Delete
              </Dropdown.Item>
              {(userType === 'super_admin' || userType === 'admin') &&
                <Dropdown.Item className="d-flex align-items-center">
                  <UserRemoveIcon className="dropdown-icon text-danger me-2" />
                  Blacklist
                </Dropdown.Item>}
            </Dropdown.Menu>
          </Dropdown> */}
            {(userType === "super_admin" || userType === "admin") && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip className="m-0">Deactivate</Tooltip>}
              >
                <Card.Link
                  className="ms-2"
                  onClick={() => blacklistUsers(props.template_id)}
                >
                  <MdAppBlocking className="icon icon-xxs text-danger me-2" />
                </Card.Link>
              </OverlayTrigger>
            )}
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip className="m-0">Edit</Tooltip>}
            >
              <Card.Link className="ms-2" onClick={() => editList(props.id)}>
                <TbEdit className="icon icon-xxs text-info" />
              </Card.Link>
            </OverlayTrigger>
          </td>
        )}
      </tr>
    );
  };

  return (
    <Card border={1}>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
        <InputGroup className="d-flex flex-nowrap fmxw-300">
          <InputGroup.Text>
            <SearchIcon className="icon icon-xs" />
          </InputGroup.Text>
          <Form.Control
            type="search"
            placeholder="Search Template Name/Header"
            value={searchValue}
            onChange={changeSearchValue}
          />
        </InputGroup>

        <div className="fmxw-300">
          <Select
            options={[
              { value: "MARKETING", label: "Marketing" },
              { value: "UTILITY", label: "Utility" },
              { value: "AUTHENTICATION", label: "Authentication" },
            ]}
            value={category}
            onChange={(option) => setCategory(option)}
            isClearable
            placeholder="Select Category"
            styles={{
              container: (provided) => ({
                ...provided,
                minWidth: "210px", // Set minimum width to handle longer labels
                maxWidth: "250px", // Set maximum width to prevent it from being too wide
              }),
            }}
          />
        </div>

        <div className="fmxw-300">
          <Select
            options={statusOptions}
            value={status}
            onChange={(option) => setStatus(option)}
            isClearable
            placeholder="Select Status"
            styles={{
              container: (provided) => ({
                ...provided,
                minWidth: "200px", // Set minimum width to handle longer labels
                maxWidth: "250px", // Set maximum width to prevent it from being too wide
              }),
            }}
          />
        </div>

        <div className="ms-auto d-flex gap-2">
          {userType === "enterprise" && canEdit && (
            <Button
              as={Link}
              to={{
                pathname: Routes.CreateTemplate.path,
                state: { tab: "WhatsApp" },
              }}
              variant="secondary"
              size="sm"
              className="d-inline-flex align-items-center"
            >
              <PlusIcon className="icon icon-xs" /> New Template
            </Button>
          )}

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip className="m-0">Refresh</Tooltip>}
          >
            <Button
              variant="outline-gray-300"
              className="p-2"
              onClick={handleRefresh}
            >
              <MdOutlineRefresh className="icon icon-sm" />
            </Button>
          </OverlayTrigger>

          {canDownload && (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip className="m-0">Download</Tooltip>}
            >
              <Button
                variant="outline-gray-300"
                className="p-2"
                onClick={handleDownload}
              >
                <DownloadIcon className="icon icon-sm" />
              </Button>
            </OverlayTrigger>
          )}

          <Dropdown className="">
            <Dropdown.Toggle
              split
              as={Button}
              variant="outline-gray-300"
              className="text-dark m-0 p-2"
            >
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
              <span className="small ps-2 fw-bold text-dark">Rows per page</span>
              {[10, 20, 30].map((limit) => (
                <Dropdown.Item
                  key={limit}
                  className={`d-flex align-items-center fw-bold ${
                    limit === 30 ? "rounded-bottom" : ""
                  }`}
                  onClick={() => {
                    setPagelimit(limit); // Update the page limit
                    setCurrentPage(1); // Reset the page number to 1
                  }}
                >
                  {limit}{" "}
                  {pagelimit === limit && (
                    <CheckIcon className="icon icon-xxs ms-auto" />
                  )}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                {/* <th className="border-bottom">S.No.</th> */}
                <th className="border-bottom">Template Name</th>
                <th className="border-bottom">Category</th>
                <th className="border-bottom">Header</th>
                <th className="border-bottom">Status</th>
                <th className="border-bottom">Preview</th>
                {/* <th className="border-bottom">Status Reason</th> */}
                <th className="border-bottom">Created On</th>
                {canEdit && <th className="border-bottom">Action</th>}
              </tr>
            </thead>
            <tbody className="border-0">
              {tableData.length > 0 ? (
                tableData.map((u, index) => (
                  <TableRow key={index + 1} index={index + 1} {...u} />
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <Card.Footer className="p-0 mt-3 border-0 d-flex flex-wrap align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage - 1)}
              >
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage + 1)}
              >
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </Nav>
        <small className="fw-normal small mt-2 mt-md-0">
          Showing{" "}
          <b>
            {totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-
            {pagelimit * currentPage > totalPosts
              ? totalPosts
              : pagelimit * currentPage}
          </b>{" "}
          of <b>{totalPosts}</b> entries.
        </small>
      </Card.Footer>
    </Card>
  );
};

// RCS Templates lists
export const RcsTemplateTable = () => {
  const [tableData, setTableData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [status, setStatus] = useState("");
  const [templateType, setTemplateType] = useState("");
  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);
  const [debouncedValue, setDebouncedValue] = useState("");
  const [confirmMessage, setConfirmMessage] = useState("");

  let userType = "";
  let userId = "";
  try {
    const userData = localStorage.getItem("TOKEN");
    if (userData) {
      const userObject = JSON.parse(userData);
      userType = userObject?.user_type || "";
      userId = userObject?.id || "";
    }
  } catch (e) {
    userType = "";
    userId = "";
  }

  const [getRegisteredRcsTemplates] = useGetRegisteredRcsTemplatesMutation();
  const [downloadRcsTemplateList] = useDownloadRegisteredRcsTemplatesMutation();
  const [deactivateRcsTemplate] = useDeactivateRcsTemplatesMutation();

  const fetchTableData = async () => {
    if (!userId || !currentPage || !pagelimit) return;

    try {
      const response = await getRegisteredRcsTemplates({
        page: currentPage,
        limit: pagelimit,
        status: status?.value,
        userId,
        search: debouncedValue,
        templateType: templateType?.value,
        provider: KARIX,
      });

      if (response?.data?.statusCode === 200) {
        const items = response?.data?.data?.items || [];
        const limit = response?.data?.data?.limit || pagelimit;
        const total = response?.data?.data?.total || 0;
        setTableData(items);
        setTotalPages(limit ? Math.ceil(total / limit) : 0);
        setTotalPosts(total);
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    } catch (error) {
      setTableData([]);
      setTotalPages(0);
      setTotalPosts(0);
      alert(`Error fetching RCS template data: ${error?.message || error}`);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchValue]);

  useEffect(() => {
    fetchTableData();
    // eslint-disable-next-line
  }, [
    debouncedValue,
    currentPage,
    userType,
    userId,
    status,
    pagelimit,
    templateType,
    getRegisteredRcsTemplates,
  ]);

  const handleRefresh = () => {
    fetchTableData();
  }

  const handleSearchChange = (e) => setSearchValue(e.target.value);
  // const handleStatusChange = (e) => setStatus(e.target.value);
  // const handleTemplateTypeChange = (e) => setTemplateType(e.target.value);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
  const handlePrev = () => setCurrentPage((prev) => Math.max(1, prev - 1));
  const handleNext = () =>
    setCurrentPage((prev) => Math.min(totalPages, prev + 1));

  const TooltipContent = ({ template_type, content, provider }) => {
    if (!template_type || !content) return <p className="m-0">No Content</p>;

    const isKarix =
      provider === KARIX ||
      content?.standaloneCard ||
      content?.carouselCard ||
      content?.textMessage;

    let template_content = {};

    if (isKarix) {
      switch (template_type) {
        case "carousel":
          template_content.cardContents = Array.isArray(content.carouselCard)
            ? content.carouselCard.map((each) => ({
                title: each?.cardTitle || "",
                DESCription: each?.cardDescription || "",
                imageUrl: each?.mediaUrl || "",
                suggestions: Array.isArray(each?.suggestions)
                  ? each.suggestions
                  : [],
              }))
            : [];
          break;
        case "standard":
        case "text_message":
          template_content = {
            title: content?.textMessage || "",
            DESCription: "",
            imageUrl: "",
            suggestions: Array.isArray(content?.suggestions)
              ? content.suggestions
              : [],
          };
          break;
        case "rich_card":
          template_content = {
            title: content?.standaloneCard?.cardTitle || "",
            DESCription: content?.standaloneCard?.cardDescription || "",
            imageUrl: content?.standaloneCard?.mediaUrl || "",
            suggestions: Array.isArray(content?.standaloneCard?.suggestions)
              ? content.standaloneCard.suggestions
              : [],
          };
          break;
        default:
          template_content = {};
      }
    } else {
      switch (template_type) {
        case "carousel":
          template_content.cardContents = Array.isArray(content.cardContents)
            ? content.cardContents.map((each) => ({
                title: each?.title || "",
                DESCription: each?.DESCription || "",
                imageUrl: each?.media?.contentInfo?.fileUrl || "",
                suggestions: each?.suggestions || [],
              }))
            : [];
          break;
        case "standard":
        case "text_message":
          template_content = {
            title: content?.messageText || "",
            DESCription: content?.messageDescription || "",
            imageUrl: "",
            suggestions: content?.suggestions || [],
          };
          break;
        case "rich_card":
          template_content = {
            title: content?.messageText || "",
            DESCription: content?.messageDescription || "",
            imageUrl: content?.imageUrl || "",
            suggestions: content?.suggestions || [],
          };
          break;
        default:
          template_content = {};
      }
    }

    const {
      title,
      DESCription,
      imageUrl,
      suggestions,
      cardContents = [],
    } = template_content;

    return (
      <div className="previewRCSTemp">
        {title && (
          <div className="w-100">
            <b>{title}</b>
            {imageUrl && (
              <>
                <br />
                <img src={imageUrl} alt="your input" className="icon icon-wide" />
                <br />
              </>
            )}
          </div>
        )}
        {DESCription && <p className="wp-body">{DESCription}</p>}
        {Array.isArray(suggestions) && suggestions.length > 0 && (
          <span className="wp-body">
            <b>
              {suggestions
                .map((s, i) => s?.text || s?.postbackData || "")
                .filter(Boolean)
                .join(", ")}
            </b>
          </span>
        )}
        {cardContents && cardContents.length > 0 && (
          <span className="wp-carousel">
            {cardContents.map((each, index) => (
              <span key={index}>
                <p className="mb-2">{`card ${index + 1}`}</p>
                {each.imageUrl && (
                  <img
                    src={each.imageUrl}
                    alt="input"
                    className="icon icon-wide"
                  />
                )}
                <p className="wp-body">{each.title}</p>
                <span className="wp-body">{each.DESCription}</span>
              </span>
            ))}
          </span>
        )}
      </div>
    );
  };

  const statusOptions = [
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
    { label: "Pending", value: "pending" },
  ];

  const canEdit = hasPermission("Templates", "edit");
  const canDownload = hasPermission("Templates", "download");

  const handleDownload = async () => {
    try {
      const blob = await downloadRcsTemplateList({
        status: status?.value,
        userId,
        search: debouncedValue,
        templateType: templateType?.value,
      }).unwrap();
      downloadBlobFile(blob, "RCS_Templates.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };

  const TableRow = (props) => {
    const {
      index,
      template_name,
      template_type,
      status,
      content,
      updatedAt,
      createdAt,
      template_id,
      id,
      provider,
    } = props;
    const statusVariant =
      status === "approved"
        ? "success"
        : status === "pending"
        ? "warning"
        : status?.toLowerCase() === "deactivate"
        ? "danger"
        : status === "rejected"
        ? "info"
        : "primary";

    return (
      <tr className="border-bottom" key={index}>
        <td>
          <div className="d-block">
            <span className="fw-normal text-black">{template_name}</span>
          </div>
        </td>
        <td>
          <span className="fw-normal">{template_type}</span>
        </td>
        <td>
          <span className={`fw-normal text-${statusVariant}`}>
            {capitalizeFirstLetter(status)}
          </span>
        </td>
        <td>
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip className="m-0">
                <TooltipContent
                  template_type={template_type}
                  content={content}
                  provider={provider}
                />
              </Tooltip>
            }
          >
            <Card.Link className="ms-2">
              <TbDeviceMobileMessage className="icon icon-xs text-info" />
            </Card.Link>
          </OverlayTrigger>
        </td>
      
        <td>
          <span className="fw-normal">
            {createdAt ? moment(createdAt).format("DD/MM/YYYY") : "-"}
          </span>
        </td>
      </tr>
    );
  };

  return (
    <Card border={1}>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
        <InputGroup className="d-flex flex-nowrap fmxw-300">
          <InputGroup.Text>
            <SearchIcon className="icon icon-xs" />
          </InputGroup.Text>
          <Form.Control
            type="search"
            placeholder="Search Template Name/Header"
            value={searchValue}
            onChange={handleSearchChange}
          />
        </InputGroup>

        <div className="fmxw-300">
          <Select
            options={[
              { value: "rich_card", label: "RICH CARD" },
              { value: "text_message", label: "TEXT MESSAGE" },
              { value: "carousel", label: "CAROUSEL" },
            ]}
            value={templateType}
            onChange={(option) => setTemplateType(option)}
            isClearable
            placeholder="Select Category"
            styles={{
              container: (provided) => ({
                ...provided,
                minWidth: "210px", // Set minimum width to handle longer labels
                maxWidth: "250px", // Set maximum width to prevent it from being too wide
              }),
            }}
          />
        </div>

        <div className="fmxw-300">
          <Select
            options={statusOptions}
            value={status}
            onChange={(option) => setStatus(option)}
            isClearable
            placeholder="Select Status"
            styles={{
              container: (provided) => ({
                ...provided,
                minWidth: "200px", // Set minimum width to handle longer labels
                maxWidth: "250px", // Set maximum width to prevent it from being too wide
              }),
            }}
          />
        </div>

        {/* <Form.Select
          onChange={handleStatusChange}
          value={status}
          className="fmxw-300 custom-dropdown"
        >
          {statusOptions.map((option, index) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Form.Select> */}

        {/* <Form.Select
          onChange={handleTemplateTypeChange}
          value={templateType}
          className="fmxw-300"
        >
          <option value="">All Category</option>
          <option value="rich_card">RICH CARD</option>
          <option value="text_message">TEXT MESSAGE</option>
          <option value="carousel">CAROUSEL</option>
        </Form.Select> */}

        <div className="ms-auto d-flex gap-2">
          {userType === "enterprise" && canEdit && (
            <Button
              as={Link}
              to={{
                pathname: Routes.CreateTemplate.path,
                state: { tab: "RCS" },
              }}
              variant="secondary"
              size="sm"
              className="d-inline-flex align-items-center"
            >
              <PlusIcon className="icon icon-xs" /> New Template
            </Button>
          )}

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip className="m-0">Refresh</Tooltip>}
          >
            <Button
              variant="outline-gray-300"
              className="p-2"
              onClick={handleRefresh}
            >
              <MdOutlineRefresh className="icon icon-sm" />
            </Button>
          </OverlayTrigger>

          {canDownload && (
              <OverlayTrigger
              placement="top"
              overlay={<Tooltip className="m-0">Download</Tooltip>}
            >
            <Button
              variant="outline-gray-300"
              className="p-2"
              onClick={handleDownload}
            >
              <DownloadIcon className="icon icon-sm" />
            </Button>
            </OverlayTrigger>
          )}

          <Dropdown>
            <Dropdown.Toggle
              split
              as={Button}
              variant="outline-gray-300"
              className="text-dark m-0 p-2"
            >
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
              <span className="small ps-2 fw-bold text-dark">Rows per page</span>
              {[10, 20, 30].map((limit) => (
                <Dropdown.Item
                  key={limit}
                  className={`d-flex align-items-center fw-bold ${
                    limit === 30 ? "rounded-bottom" : ""
                  }`}
                  onClick={() => {
                    setPagelimit(limit);
                    setCurrentPage(1);
                  }}
                >
                  {limit}{" "}
                  {pagelimit === limit && (
                    <CheckIcon className="icon icon-xxs ms-auto" />
                  )}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-bottom">Template Name</th>
                <th className="border-bottom">Template Type</th>
                <th className="border-bottom">Status</th>
                <th className="border-bottom">Preview</th>
                <th className="border-bottom">Created On</th>
              </tr>
            </thead>
            <tbody className="border-0">
              {tableData.length > 0 ? (
                tableData.map((u, index) => (
                  <TableRow
                    key={u.template_id || u.id || index}
                    index={index + 1}
                    {...u}
                  />
                ))
              ) : (
                <tr>
                  <td
                    colSpan={canEdit ? 7 : 5}
                    className="text-center text-danger"
                  >
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <Card.Footer className="p-0 mt-3 border-0 d-flex flex-wrap align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage - 1)}
              >
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage + 1)}
              >
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next
              onClick={handleNext}
              disabled={currentPage === totalPages || totalPages === 0}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </Nav>
        <small className="fw-normal small mt-2 mt-md-0">
          Showing{" "}
          <b>
            {totalPosts === 0
              ? 0
              : `${pagelimit * (currentPage - 1) + 1}-${Math.min(
                  pagelimit * currentPage,
                  totalPosts
                )}`}
          </b>{" "}
          of <b>{totalPosts}</b> entries.
        </small>
      </Card.Footer>
    </Card>
  );
};

// WA BSPs lists
export const RoutesTable = () => {
  const [tableData, setTableData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [status, setStatus] = useState("");

  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);
  const [debouncedValue, setDebouncedValue] = useState("");

  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const startDate = start ? moment(start).format("YYYY-MM-DD") : "";
  const endDate = end ? moment(end).format("YYYY-MM-DD") : "";

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // Get the id from localStorage
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const userType = userObject.user_type;
  // const userId = userObject.id;

  const [RoutesList] = useGetRoutesListMutation();

  useEffect(() => {
    const fetchTableData = async () => {
      try {
        const response = await RoutesList({
          comm_type: status,
          page: currentPage,
          limit: pagelimit,
          // search: searchValue,
          // startDate: startDate,
          // endDate: endDate
        });

        if (response?.data?.statusCode === 200) {
          setTableData(response?.data?.data?.rows || []);
          setTotalPages(response?.data?.data?.totalPages || 0);
          setTotalPosts(response?.data?.data?.totalItems || 0);
        } else {
          setTableData({});
          setTotalPages(0);
          setTotalPosts(0);
          // alert('Failed to fetch user data');
        }
      } catch (error) {
        setTableData({});
        setTotalPages(0);
        setTotalPosts(0);
        // alert('Error fetching user data', error);
      }
    };
    fetchTableData();
  }, [currentPage, pagelimit, status, debouncedValue, startDate, endDate]);

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 1000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
  };
  const handleStatus = (e) => {
    setStatus(e.target.value);
  };

  const reject = async (ids) => {
    const usersToBeDeleted = ids;
    // const usersNr = usersToBeDeleted.length;
    const textMessage = "Are you sure do you want to Reject this Enterprise?";

    const result = await SwalWithBootstrapButtons.fire({
      icon: "error",
      title: "Confirmation",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      // const newUsers = tableData.filter(f => !usersToBeDeleted.includes(f.id));

      // deleteListApi({ id: ids })
      //     .then((response) => {
      //         if (response?.data?.statusCode === 200) {
      //             setMessage('The List has been deleted.')
      //         } else {
      //             setError('Failed to Delete.');
      //         }
      //     })
      //     .catch((error) => {
      //         setError('Error deleting this list.' || error);
      //     });

      const handleSwal = async () => {
        if (message !== "") {
          await SwalWithBootstrapButtons.fire("Rejected", message, "success");
        } else {
          await SwalWithBootstrapButtons.fire("Failed", error, "error");
        }
      };
      handleSwal();
    }
  };

  const approve = (ids) => {};

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const TableRow = (props) => {
    const variant =
      props.comm_type === "whatsapp"
        ? "success"
        : props.comm_type === "sms"
        ? "purple"
        : props.comm_type === "rcs"
        ? "warning"
        : "primary";
    return (
      <tr className="border-bottom">
        <td>
          <span
            className={`fw-normal text-uppercase`}
            title={props.comm_type || "-"}
          >
            {props.comm_type || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.route_name || "-"}>
            {props.route_name || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.details || "-"}>
            {props.details || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.user_name || "-"}>
            {props.user_name || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.password || "-"}>
            {props.password || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.method || "-"}>
            {props.method || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.key_type || "-"}>
            {props.key_type || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.key_value || "-"}>
            {props.key_value || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.cost || "-"}>
            {props.cost || "-"}
          </span>
        </td>
      </tr>
    );
  };

  const canDownload = hasPermission("WA BSPs", "download");

  return (
    <Card border={1}>
      <div className="d-flex flex-wrap align-items-center gap-2">

        <div className="ms-auto d-flex mb-3 gap-2">
          {canDownload && (
            <Button variant="outline-gray-300" className="p-2">
              <DownloadIcon className="icon icon-sm" />
            </Button>
          )}

          <Dropdown>
            <Dropdown.Toggle
              split
              as={Button}
              variant="outline-gray-300"
              className="text-dark m-0 p-2"
            >
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end pb-0">
              <span className="small ps-2 fw-bold text-dark">Rows per page</span>
              {[10, 20, 30].map((limit) => (
                <Dropdown.Item
                  key={limit}
                  className={`d-flex align-items-center fw-bold ${
                    limit === 30 ? "rounded-bottom" : ""
                  }`}
                  onClick={() => {
                    setPagelimit(limit); // Update the page limit
                    setCurrentPage(1); // Reset the page number to 1
                  }}
                >
                  {limit}
                  {pagelimit === limit && (
                    <CheckIcon className="icon icon-xxs ms-auto" />
                  )}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-bottom">Message Type</th>
                <th className="border-bottom">Route Name</th>
                <th className="border-bottom">Route Detail</th>
                <th className="border-bottom">Username</th>
                <th className="border-bottom">Password</th>
                <th className="border-bottom">API Method</th>
                <th className="border-bottom">Key Type</th>
                <th className="border-bottom">Key Value</th>
                <th className="border-bottom">Cost Rate</th>
              </tr>
            </thead>
            <tbody className="border-0">
              {tableData.length > 0 ? (
                tableData.map((u, index) => (
                  <TableRow key={index + 1} index={index + 1} {...u} />
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      <Card.Footer className="p-0 mt-3 border-0 d-flex flex-wrap align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage - 1)}
              >
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage + 1)}
              >
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </Nav>
        <small className="fw-normal small mt-2 mt-md-0">
          Showing{" "}
          <b>
            {totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-
            {pagelimit * currentPage > totalPosts
              ? totalPosts
              : pagelimit * currentPage}
          </b>{" "}
          of <b>{totalPosts}</b> entries.
        </small>
      </Card.Footer>
    </Card>
  );
};
// WA Rate lists
export const MessageRateTable = () => {
  const [tableData, setTableData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [status, setStatus] = useState("");

  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);
  const [debouncedValue, setDebouncedValue] = useState("");

  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // Get the id from localStorage
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const userType = userObject.user_type;
  // const userId = userObject.id;

  const [RatesList] = useGetMsgRatesListMutation();
  const [download] = useDnldWARatesMutation();

  useEffect(() => {
    const fetchTableData = async () => {
      RatesList({
        // comm_type: status,
        page: currentPage,
        limit: pagelimit,
        search: searchValue,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
      })
        .then((response) => {
          if (response?.data?.statusCode === 200) {
            setTableData(response?.data?.data?.items || []);
            setTotalPages(
              Math.ceil(response?.data?.data?.totalItems / pagelimit)
            );
            setTotalPosts(response?.data?.data?.totalItems || 0);
          } else {
            setTableData([]);
            setTotalPages(0);
            setTotalPosts(0);
            // alert('Failed to fetch user data');
          }
        })
        .catch((error) => {
          setTableData([]);
          setTotalPages(0);
          setTotalPosts(0);
          // alert('Error fetching user data', error);
        });
    };
    fetchTableData();
  }, [currentPage, pagelimit, status, debouncedValue, start, end]);

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 1000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
  };
  const handleStatus = (e) => {
    setStatus(e.target.value);
  };

  const reject = async (ids) => {
    const usersToBeDeleted = ids;
    // const usersNr = usersToBeDeleted.length;
    const textMessage = "Are you sure do you want to Reject this Enterprise?";

    const result = await SwalWithBootstrapButtons.fire({
      icon: "error",
      title: "Confirmation",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      // const newUsers = tableData.filter(f => !usersToBeDeleted.includes(f.id));

      // deleteListApi({ id: ids })
      //     .then((response) => {
      //         if (response?.data?.statusCode === 200) {
      //             setMessage('The List has been deleted.')
      //         } else {
      //             setError('Failed to Delete.');
      //         }
      //     })
      //     .catch((error) => {
      //         setError('Error deleting this list.' || error);
      //     });

      const handleSwal = async () => {
        if (message !== "") {
          await SwalWithBootstrapButtons.fire("Rejected", message, "success");
        } else {
          await SwalWithBootstrapButtons.fire("Failed", error, "error");
        }
      };
      handleSwal();
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const TableRow = (props) => {
    const statusVariant =
      props.status === "active"
        ? "success"
        : props.status === "pending"
        ? "purple"
        : props.status === "rejected"
        ? "danger"
        : "primary";
    const channelVariant =
      props.channel === "whatsapp"
        ? "success"
        : props.comm_type === "sms"
        ? "purple"
        : props.comm_type === "rcs"
        ? "warning"
        : "primary";
    return (
      <tr className="border-bottom">
        <td>
          <span title={props.assigned_to || "-"} className="fw-normal">
            {props.assigned_to}
          </span>
        </td>
        <td>
          <span title={props.route_name || "-"} className="fw-normal">
            {props.route_name}
          </span>
        </td>
        <td>
          <span
            title={props.message_type || "-"}
            className={`fw-normal text-${channelVariant}`}
          >
            {props.message_type}
          </span>
        </td>
        <td>
          <span
            title={moment(props.date).format("DD/MM/YYYY") || "-"}
            className="fw-normal"
          >
            {moment(props.date).format("DD/MM/YYYY")}
          </span>
        </td>
        <td>
          <span title={props.created_by_user || "-"} className="fw-normal">
            {props.created_by_user}
          </span>
        </td>
        <td>
          <span title={props.transactional_rate || "-"} className="fw-normal">
            {props.transactional_rate}
          </span>
        </td>
        <td>
          <span title={props.promotional_rate || "-"} className="fw-normal">
            {props.promotional_rate}
          </span>
        </td>
        <td>
          <span title={props.authentication_rate || "-"} className="fw-normal">
            {props.authentication_rate}
          </span>
        </td>
        <td>
          <span
            title={props.status || "-"}
            className={`fw-normal text-${statusVariant} text-capitalize`}
          >
            {props.status}
          </span>
        </td>
        {/* {userType === 'super_admin' && <td>
          <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Approve</Tooltip>}>
            <Card.Link onClick={() => approve(props.id)}>
              <CheckIcon className="icon icon-xs text-success" />
            </Card.Link>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Reject</Tooltip>}>
            <Card.Link className="ms-2" onClick={() => reject(props.id)}>
              <XIcon className="icon icon-xs text-danger" />
            </Card.Link>
          </OverlayTrigger>
        </td>} */}
      </tr>
    );
  };

  const canDownload = hasPermission("WA Rates", "download");
  const handleDownload = async () => {
    try {
      const blob = await download({
        search: searchValue,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
        loggedin_user_id: userObject.id,
        user_type_id: userObject.user_type_id,
      }).unwrap();
      downloadBlobFile(blob, "WhatsApp_Rates.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };

  return (
    <Card border={1}>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
        <InputGroup className="d-flex flex-nowrap  fmxw-300">
          <InputGroup.Text>
            <SearchIcon className="icon icon-xs" />
          </InputGroup.Text>
          <Form.Control
            type="search"
            placeholder="Enterprise Name"
            value={searchValue}
            onChange={changeSearchValue}
          />
        </InputGroup>
        {/* <Form.Select
              onChange={handleStatus}
              value={status}
              className="me-2 me-lg-3 mb-3 fmxw-300"
            >
              <option value="" defaultValue>
                All Channel
              </option>
              <option>SMS</option>
              <option>WhatsApp</option>
              <option>RCS</option>
            </Form.Select> */}
      <Form.Group id="DateRange">
                        <InputGroup className="d-flex flex-nowrap">
                          <InputGroup.Text
                            onClick={() => {
                              setStart(null);
                              setEnd(null);
                            }}
                          >
                            {start || end ? (
                              <XCircleIcon className="icon icon-xs" />
                            ) : (
                              <CalendarIcon className="icon icon-xs" />
                            )}
                          </InputGroup.Text>
                          <Datetime
                            timeFormat={false}
                            onChange={(date) => {
                              if (moment.isMoment(date)) {
                                setStart(date);
                              }
                            }}
                            closeOnSelect={true}
                            renderInput={(props, openCalendar) => (
                              <Form.Control
                                type="search"
                                placeholder="Start Date"
                                value={
                                  start ? moment(start).format("DD/MM/YYYY") : ""
                                }
                                onFocus={openCalendar}
                                readOnly
                                style={{ width: "150px", borderRadius: "0" }}
                              />
                            )}
                          />
                          <Datetime
                            timeFormat={false}
                            onChange={(date) => {
                              if (moment.isMoment(date)) {
                                setEnd(date);
                              }
                            }}
                            closeOnSelect={true}
                            isValidDate={(currDate) => currDate.isAfter(start)}
                            initialViewDate={end}
                            renderInput={(props, openCalendar) => (
                              <Form.Control
                                type="search"
                                placeholder="End Date"
                                value={end ? moment(end).format("DD/MM/YYYY") : ""}
                                onFocus={openCalendar}
                                readOnly
                                style={{
                                  width: "150px",
                                  borderTopLeftRadius: "0",
                                  borderBottomLeftRadius: "0",
                                }}
                              />
                            )}
                          />
                        </InputGroup>
                      </Form.Group>

        <div className="ms-auto d-inline-flex gap-2 mb-3">
          {canDownload && (
            <Button
              variant="outline-gray-300"
              className="p-2"
              onClick={handleDownload}
            >
              <DownloadIcon className="icon icon-sm" />
            </Button>
          )}

          <Dropdown>
            <Dropdown.Toggle
              split
              as={Button}
              variant="outline-gray-300"
              className="text-dark m-0 p-2"
            >
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end pb-0">
              <span className="small ps-2 fw-bold text-dark">
                Rows per page
              </span>
              {[10, 20, 30].map((limit) => (
                <Dropdown.Item
                  key={limit}
                  className={`d-flex align-items-center fw-bold ${
                    limit === 30 ? "rounded-bottom" : ""
                  }`}
                  onClick={() => {
                    setPagelimit(limit); // Update the page limit
                    setCurrentPage(1); // Reset the page number to 1
                  }}
                >
                  {limit}{" "}
                  {pagelimit === limit && (
                    <CheckIcon className="icon icon-xxs ms-auto" />
                  )}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-bottom">Enterprise Name</th>
                <th className="border-bottom">Route Name</th>
                <th className="border-bottom">Message Type</th>
                <th className="border-bottom" style={{ minWidth: "100px" }}>
                  Date
                </th>
                <th className="border-bottom">Submitted By</th>
                <th className="border-bottom">Transactional Rate</th>
                <th className="border-bottom">Promotional Rate</th>
                <th className="border-bottom">Authentication Rate</th>
                <th className="border-bottom">Status</th>
                {/* {userType === 'super_admin' && <th className="border-bottom">Action</th>} */}
              </tr>
            </thead>
            <tbody className="border-0">
              {tableData.length > 0 ? (
                tableData.map((u, index) => (
                  <TableRow key={index + 1} index={index + 1} {...u} />
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <Card.Footer className="mt-3 p-0 border-0 d-flex flex-wrap align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage - 1)}
              >
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage + 1)}
              >
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </Nav>
        <small className="fw-normal small mt-2 mt-md-0">
          Showing{" "}
          <b>
            {totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-
            {pagelimit * currentPage > totalPosts
              ? totalPosts
              : pagelimit * currentPage}
          </b>{" "}
          of <b>{totalPosts}</b> entries.
        </small>
      </Card.Footer>
    </Card>
  );
};

// RCS BSPs
export const RcsBspTable = () => {
  const [tableData, setTableData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);
  const [debouncedValue, setDebouncedValue] = useState("");

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const [RcsBspList] = useGetRcsOnboardedBSPMutation();

  useEffect(() => {
    const fetchTableData = async () => {
      try {
        const response = await RcsBspList({
          page: currentPage,
          limit: pagelimit,
          search: searchValue,
        });

        if (response?.data?.statusCode === 200) {
          setTableData(response?.data?.data?.items || []);
          const total = Math.ceil(
            response?.data?.data?.total / response?.data?.data?.limit
          );
          setTotalPages(total || 0);
          setTotalPosts(response?.data?.data?.total || 0);
        } else {
          setTableData({});
          setTotalPages(0);
          setTotalPosts(0);
        }
      } catch (error) {
        setTableData({});
        setTotalPages(0);
        setTotalPosts(0);
      }
    };
    fetchTableData();
  }, [currentPage, pagelimit, debouncedValue]);

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue);
    }, 1000);
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const TableRow = (props) => {
    const variant =
      props.comm_type === "whatsapp"
        ? "success"
        : props.comm_type === "sms"
        ? "purple"
        : props.comm_type === "rcs"
        ? "warning"
        : "primary";
    return (
      <tr className="border-bottom">
        <td>
          <span
            className={`fw-normal text-uppercase`}
            title={props.route_name || "-"}
          >
            {props.route_name || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.cost || "-"}>
            {props.cost || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.status || "-"}>
            {props.status || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.username || "-"}>
            {props.username || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.password || "-"}>
            {props.password || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.keyType || "-"}>
            {props.keyType || "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.keyValue || "-"}>
            {props.keyValue || "-"}
          </span>
        </td>
      </tr>
    );
  };

  const canDownload = hasPermission("WA BSPs", "download");

  return (
    <Card border={1}>
      <div className="d-flex flex-wrap align-items-center gap-2">
        <div className="ms-auto d-flex mb-3 gap-2">
          {canDownload && (
            <Button variant="outline-gray-300" className="p-2">
              <DownloadIcon className="icon icon-sm" />
            </Button>
          )}

          <Dropdown>
            <Dropdown.Toggle
              split
              as={Button}
              variant="outline-gray-300"
              className="text-dark m-0 p-2"
            >
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end pb-0">
              <span className="small ps-2 fw-bold text-dark">Rows per page</span>
              {[10, 20, 30].map((limit) => (
                <Dropdown.Item
                  key={limit}
                  className={`d-flex align-items-center fw-bold ${
                    limit === 30 ? "rounded-bottom" : ""
                  }`}
                  onClick={() => {
                    setPagelimit(limit);
                    setCurrentPage(1);
                  }}
                >
                  {limit}
                  {pagelimit === limit && (
                    <CheckIcon className="icon icon-xxs ms-auto" />
                  )}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-bottom">Route Name</th>
                <th className="border-bottom">Cost Rate</th>
                <th className="border-bottom">Status</th>
                <th className="border-bottom">Username</th>
                <th className="border-bottom">Password</th>
                <th className="border-bottom">Key Type</th>
                <th className="border-bottom">Key Value</th>
              </tr>
            </thead>
            <tbody className="border-0">
              {tableData.length > 0 ? (
                tableData.map((u, index) => (
                  <TableRow key={index + 1} index={index + 1} {...u} />
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      <Card.Footer className="p-0 mt-3 border-0 d-flex flex-wrap align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage - 1)}
              >
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage + 1)}
              >
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </Nav>
        <small className="fw-normal small mt-2 mt-md-0">
          Showing{" "}
          <b>
            {totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-
            {pagelimit * currentPage > totalPosts
              ? totalPosts
              : pagelimit * currentPage}
          </b>{" "}
          of <b>{totalPosts}</b> entries.
        </small>
      </Card.Footer>
    </Card>
  );
};

export const RcsRateTable = () => {
  const [tableData, setTableData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [status, setStatus] = useState("");

  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);
  const [debouncedValue, setDebouncedValue] = useState("");

  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // Get the id from localStorage
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const userType = userObject.user_type;
  // const userId = userObject.id;

  const [RatesList] = useGetRcsAssignedRoutesMutation();
  const [download] = useDnldWARatesMutation();

  useEffect(() => {
    const fetchTableData = async () => {
      RatesList({
        page: currentPage,
        limit: pagelimit,
        search: searchValue,
        status: "",
        provider: KARIX,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
      })
        .then((response) => {
          if (
            response?.data?.statusCode === 200 ||
            response?.data?.data?.items?.length > 0
          ) {
            setTableData(response?.data?.data?.items || []);
            setTotalPages(Math.ceil(response?.data?.data?.total / pagelimit));
            setTotalPosts(response?.data?.data?.total || 0);
          } else {
            setTableData([]);
            setTotalPages(0);
            setTotalPosts(0);
            // alert('Failed to fetch user data');
          }
        })
        .catch((error) => {
          setTableData([]);
          setTotalPages(0);
          setTotalPosts(0);
          // alert('Error fetching user data', error);
        });
    };
    fetchTableData();
  }, [currentPage, pagelimit, status, debouncedValue, start, end]);

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 1000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
  };
  const handleStatus = (e) => {
    setStatus(e.target.value);
  };

  const reject = async (ids) => {
    const usersToBeDeleted = ids;
    // const usersNr = usersToBeDeleted.length;
    const textMessage = "Are you sure do you want to Reject this Enterprise?";

    const result = await SwalWithBootstrapButtons.fire({
      icon: "error",
      title: "Confirmation",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      // const newUsers = tableData.filter(f => !usersToBeDeleted.includes(f.id));

      // deleteListApi({ id: ids })
      //     .then((response) => {
      //         if (response?.data?.statusCode === 200) {
      //             setMessage('The List has been deleted.')
      //         } else {
      //             setError('Failed to Delete.');
      //         }
      //     })
      //     .catch((error) => {
      //         setError('Error deleting this list.' || error);
      //     });

      const handleSwal = async () => {
        if (message !== "") {
          await SwalWithBootstrapButtons.fire("Rejected", message, "success");
        } else {
          await SwalWithBootstrapButtons.fire("Failed", error, "error");
        }
      };
      handleSwal();
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const TableRow = (props) => {
    const statusVariant =
      props.status === "active"
        ? "success"
        : props.status === "pending"
        ? "purple"
        : props.status === "rejected"
        ? "danger"
        : "primary";
    const channelVariant =
      props.channel === "whatsapp"
        ? "success"
        : props.comm_type === "sms"
        ? "purple"
        : props.comm_type === "rcs"
        ? "warning"
        : "primary";
    return (
      <tr className="border-bottom">
        <td>
          <span title={props.enterprise_name || "-"} className="fw-normal">
            {props.enterprise_name}
          </span>
        </td>
        <td>
          <span title={props.route_name || "-"} className="fw-normal">
            {props.route_name}
          </span>
        </td>
        <td>
          <span
            title={moment(props.date).format("DD/MM/YYYY") || "-"}
            className="fw-normal"
          >
            {moment(props.date).format("DD/MM/YYYY")}
          </span>
        </td>
        <td>
          <span title={props.created_by_user || "-"} className="fw-normal">
            {props.created_by_user}
          </span>
        </td>
        <td>
          <span title={props.standard_rate || "-"} className="fw-normal">
            {props.standard_rate}
          </span>
        </td>
        <td>
          <span title={props.rich_card_rate || "-"} className="fw-normal">
            {props.rich_card_rate}
          </span>
        </td>
        <td>
          <span title={props.carousel_rate || "-"} className="fw-normal">
            {props.carousel_rate}
          </span>
        </td>
        <td>
          <span title={props.sell_price || "-"} className="fw-normal">
            {props.sell_price}
          </span>
        </td>
        <td>
          <span
            title={props.status || "-"}
            className={`fw-normal text-${statusVariant} text-capitalize`}
          >
            {props.status}
          </span>
        </td>
        {/* {userType === 'super_admin' && <td>
          <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Approve</Tooltip>}>
            <Card.Link onClick={() => approve(props.id)}>
              <CheckIcon className="icon icon-xs text-success" />
            </Card.Link>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Reject</Tooltip>}>
            <Card.Link className="ms-2" onClick={() => reject(props.id)}>
              <XIcon className="icon icon-xs text-danger" />
            </Card.Link>
          </OverlayTrigger>
        </td>} */}
      </tr>
    );
  };

  const canDownload = hasPermission("WA Rates", "download");
  const handleDownload = async () => {
    try {
      const blob = await download({
        search: searchValue,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
        loggedin_user_id: userObject.id,
        user_type_id: userObject.user_type_id,
      }).unwrap();
      downloadBlobFile(blob, "WhatsApp_Rates.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };

  return (
    <Card border={1}>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
        <InputGroup className="d-flex flex-nowrap fmxw-300">
          <InputGroup.Text>
            <SearchIcon className="icon icon-xs" />
          </InputGroup.Text>
          <Form.Control
            type="search"
            placeholder="Enterprise Name"
            value={searchValue}
            onChange={changeSearchValue}
          />
        </InputGroup>
         <Form.Group id="DateRange">
                          <InputGroup className="d-flex flex-nowrap">
                            <InputGroup.Text
                              onClick={() => {
                                setStart(null);
                                setEnd(null);
                              }}
                            >
                              {start || end ? (
                                <XCircleIcon className="icon icon-xs" />
                              ) : (
                                <CalendarIcon className="icon icon-xs" />
                              )}
                            </InputGroup.Text>
                            <Datetime
                              timeFormat={false}
                              onChange={(date) => {
                                if (moment.isMoment(date)) {
                                  setStart(date);
                                }
                              }}
                              closeOnSelect={true}
                              renderInput={(props, openCalendar) => (
                                <Form.Control
                                  type="search"
                                  placeholder="Start Date"
                                  value={
                                    start ? moment(start).format("DD/MM/YYYY") : ""
                                  }
                                  onFocus={openCalendar}
                                  readOnly
                                  style={{ width: "150px", borderRadius: "0" }}
                                />
                              )}
                            />
                            <Datetime
                              timeFormat={false}
                              onChange={(date) => {
                                if (moment.isMoment(date)) {
                                  setEnd(date);
                                }
                              }}
                              closeOnSelect={true}
                              isValidDate={(currDate) => currDate.isAfter(start)}
                              initialViewDate={end}
                              renderInput={(props, openCalendar) => (
                                <Form.Control
                                  type="search"
                                  placeholder="End Date"
                                  value={end ? moment(end).format("DD/MM/YYYY") : ""}
                                  onFocus={openCalendar}
                                  readOnly
                                  style={{
                                    width: "150px",
                                    borderTopLeftRadius: "0",
                                    borderBottomLeftRadius: "0",
                                  }}
                                />
                              )}
                            />
                          </InputGroup>
                        </Form.Group>

        <div className="ms-auto d-inline-flex gap-2">
          {canDownload && (
            <Button
              variant="outline-gray-300"
              className="p-2"
              onClick={handleDownload}
            >
              <DownloadIcon className="icon icon-sm" />
            </Button>
          )}

          <Dropdown>
            <Dropdown.Toggle
              split
              as={Button}
              variant="outline-gray-300"
              className="text-dark m-0 p-2"
            >
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end pb-0">
              <span className="small ps-2 fw-bold text-dark">
                Rows per page
              </span>
              {[10, 20, 30].map((limit) => (
                <Dropdown.Item
                  key={limit}
                  className={`d-flex align-items-center fw-bold ${
                    limit === 30 ? "rounded-bottom" : ""
                  }`}
                  onClick={() => {
                    setPagelimit(limit); // Update the page limit
                    setCurrentPage(1); // Reset the page number to 1
                  }}
                >
                  {limit}{" "}
                  {pagelimit === limit && (
                    <CheckIcon className="icon icon-xxs ms-auto" />
                  )}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-bottom">Enterprise Name</th>
                <th className="border-bottom">Route Name</th>
                <th className="border-bottom" style={{ minWidth: "100px" }}>
                  Date
                </th>
                <th className="border-bottom">Submitted By</th>
                <th className="border-bottom">Standard Rate</th>
                <th className="border-bottom">Rich Card Rate</th>
                <th className="border-bottom">Carousel Rate</th>
                <th className="border-bottom">Sell Price</th>
                <th className="border-bottom">Status</th>
              </tr>
            </thead>
            <tbody className="border-0">
              {tableData.length > 0 ? (
                tableData.map((u, index) => (
                  <TableRow key={index + 1} index={index + 1} {...u} />
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <Card.Footer className="mt-3 p-0 border-0 d-flex flex-wrap align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage - 1)}
              >
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage + 1)}
              >
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </Nav>
        <small className="fw-normal small mt-2 mt-md-0">
          Showing{" "}
          <b>
            {totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-
            {pagelimit * currentPage > totalPosts
              ? totalPosts
              : pagelimit * currentPage}
          </b>{" "}
          of <b>{totalPosts}</b> entries.
        </small>
      </Card.Footer>
    </Card>
  );
};

// Chatbot API Table
export const ChatFlowApiTables = ({ handleEditAPI }) => {
  // Get the usertype from localStorage
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);

  const [tableData, setTableData] = useState([]);

  const [searchValue, setSearchValue] = useState("");
  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);

  // const [userType, setUserType] = useState("");
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const [storedAPIs] = useGetStoredAPIsMutation();
  const [download] = useDnldSavedApisMutation();
  const [deleteAPI] = useDeleteSavedAPIsMutation();

  const [debouncedValue, setDebouncedValue] = useState("");

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 1000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  useEffect(() => {
    fetchTableData();
  }, [currentPage, pagelimit, debouncedValue, start, end]);

  const fetchTableData = async () => {
    storedAPIs({
      page: currentPage,
      limit: pagelimit,
      search: searchValue,
      startDate: start ? start.format("YYYY-MM-DD") : "",
      endDate: end ? end.format("YYYY-MM-DD") : "",
    })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setTableData(response?.data?.data.items || []);
          setTotalPages(response?.data?.data?.totalPages || 0);
          setTotalPosts(response?.data?.data?.total || 0);
        } else {
          setTableData([]);
          setTotalPages(0);
          setTotalPosts(0);
        }
      })
      .catch((error) => {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      });
  };

  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    // if (currentPage < totalPages) {
    setCurrentPage(currentPage + 1);
    // }
  };

  const handledeleteAPI = async (ids) => {
    const textMessage = "Are you sure you want to Delete this API?";

    const result = await SwalWithBootstrapButtons.fire({
      icon: "question",
      title: "Confirmation",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      deleteAPI({ id: ids })
        .then((response) => {
          if (
            response?.data?.statusCode >= 200 &&
            response?.data?.statusCode <= 204
          ) {
            let confirmMessage =
              response?.data?.message || "API deleted successfully!";
            SwalWithBootstrapButtons.fire(
              "API deleted successfully!",
              confirmMessage,
              "success"
            );
          } else {
            let confirmMessage =
              response?.data?.message || "Failed to Delete API.";
            SwalWithBootstrapButtons.fire(
              "Deletion Failed",
              confirmMessage,
              "error"
            );
          }
        })
        .catch((error) => {
          let confirmMessage = error?.message || "Server Error!";
          SwalWithBootstrapButtons.fire(
            "Deletion Failed",
            confirmMessage,
            "error"
          );
        });
    }
    setDebouncedValue();
  };

  const handleDownload = async () => {
    try {
      const blob = await download({
        search: searchValue,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
        user_id: userObject.id,
        user_type_id: userObject.user_type_id || "1",
        loggedin_user_id: userObject.id,
      }).unwrap();
      downloadBlobFile(blob, "Chatbot_APIs.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };

  const TableRow = (props) => {
    const { index } = props;

    return (
      <tr className="border-bottom" key={index}>
        <td>
          <span className="fw-normal" title={props.api_name}>
            {props.api_name}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.api_type || "-"}>
            {props.api_type ?? "-"}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={props.api_url || "-"}>
            {props.api_url ?? "-"}
          </span>
        </td>
        <td>
          <span
            title={moment(props.createdAt).format("DD/MM/YYYY") || "-"}
            className="fw-normal"
          >
            {moment(props.createdAt).format("DD/MM/YYYY")}
          </span>
        </td>
        <td>
          <div className="d-flex align-items-center gap-2">
            {/* <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Edit</Tooltip>}>
              <Card.Link className="ms-2" onClick={() => handleEditAPI(props)}>
                <TbEdit className="icon icon-xxs text-info" />
              </Card.Link>
            </OverlayTrigger> */}
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip className="m-0">Delete</Tooltip>}
            >
              <Card.Link
                className="ms-2"
                onClick={() => handledeleteAPI(props.id)}
              >
                <XCircleIcon className="icon icon-xxs text-danger" />
              </Card.Link>
            </OverlayTrigger>
          </div>
        </td>
      </tr>
    );
  };

  return (
    <Card border={1}>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
        {/* Search Input */}
        <InputGroup className="fmxw-300">
          <InputGroup.Text>
            <SearchIcon className="icon icon-xs" />
          </InputGroup.Text>
          <Form.Control
            type="search"
            placeholder="Search API Name"
            value={searchValue}
            onChange={changeSearchValue}
          />
        </InputGroup>

      <Form.Group id="DateRange">
                       <InputGroup className="d-flex flex-nowrap">
                         <InputGroup.Text
                           onClick={() => {
                             setStart(null);
                             setEnd(null);
                           }}
                         >
                           {start || end ? (
                             <XCircleIcon className="icon icon-xs" />
                           ) : (
                             <CalendarIcon className="icon icon-xs" />
                           )}
                         </InputGroup.Text>
                         <Datetime
                           timeFormat={false}
                           onChange={(date) => {
                             if (moment.isMoment(date)) {
                               setStart(date);
                             }
                           }}
                           closeOnSelect={true}
                           renderInput={(props, openCalendar) => (
                             <Form.Control
                               type="search"
                               placeholder="Start Date"
                               value={
                                 start ? moment(start).format("DD/MM/YYYY") : ""
                               }
                               onFocus={openCalendar}
                               readOnly
                               style={{ width: "150px", borderRadius: "0" }}
                             />
                           )}
                         />
                         <Datetime
                           timeFormat={false}
                           onChange={(date) => {
                             if (moment.isMoment(date)) {
                               setEnd(date);
                             }
                           }}
                           closeOnSelect={true}
                           isValidDate={(currDate) => currDate.isAfter(start)}
                           initialViewDate={end}
                           renderInput={(props, openCalendar) => (
                             <Form.Control
                               type="search"
                               placeholder="End Date"
                               value={end ? moment(end).format("DD/MM/YYYY") : ""}
                               onFocus={openCalendar}
                               readOnly
                               style={{
                                 width: "150px",
                                 borderTopLeftRadius: "0",
                                 borderBottomLeftRadius: "0",
                               }}
                             />
                           )}
                         />
                       </InputGroup>
                     </Form.Group>

        <div className="ms-auto d-inline-flex gap-2">
          <Button
            variant="outline-gray-300"
            className="p-2"
            onClick={handleDownload}
          >
            <DownloadIcon className="icon icon-sm" />
          </Button>

          <Dropdown>
            <Dropdown.Toggle
              split
              as={Button}
              variant="outline-gray-300"
              className="text-dark m-0 p-2"
            >
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
              <span className="small ps-2 fw-bold text-dark">
                Rows per page
              </span>
              <Dropdown.Item
                className="d-flex align-items-center fw-bold"
                value="10"
                onClick={() => setPagelimit(10)}
              >
                10{" "}
                {pagelimit == 10 && (
                  <CheckIcon className="icon icon-xxs ms-auto" />
                )}
              </Dropdown.Item>
              <Dropdown.Item
                className="d-flex align-items-center fw-bold"
                value="20"
                onClick={() => setPagelimit("20")}
              >
                20{" "}
                {pagelimit == 20 && (
                  <CheckIcon className="icon icon-xxs ms-auto" />
                )}
              </Dropdown.Item>
              <Dropdown.Item
                className="d-flex align-items-center fw-bold rounded-bottom"
                value="30"
                onClick={() => setPagelimit("30")}
              >
                30{" "}
                {pagelimit == 30 && (
                  <CheckIcon className="icon icon-xxs ms-auto" />
                )}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-bottom">API Name</th>
                <th className="border-bottom">API Type</th>
                <th className="border-bottom" style={{ width: "450px" }}>
                  URL
                </th>
                <th className="border-bottom">Created On</th>
                <th className="border-bottom">Action</th>
              </tr>
            </thead>
            <tbody className="border-0">
              {tableData.length > 0 ? (
                tableData.map((u, index) => (
                  <TableRow key={index + 1} index={index + 1} {...u} />
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <Card.Footer className="p-0 mt-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>
                  1
                </Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage - 1)}
              >
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item
                onClick={() => handlePageChange(currentPage + 1)}
              >
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </Nav>
        <small className="fw-normal small mt-2 mt-md-0">
          Showing{" "}
          <b>
            {totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-
            {pagelimit * currentPage > totalPosts
              ? totalPosts
              : pagelimit * currentPage}
          </b>{" "}
          of <b>{totalPosts}</b> entries.
        </small>
      </Card.Footer>
    </Card>
  );
};